// AUTO-GENERATED by scripts/i18n-gen-index.cjs — do not hand-edit.
// Regenerate after adding/removing a catalog/en/*.json namespace file:
//   node scripts/i18n-gen-index.cjs
// Namespace contents are inlined as object literals, not imported from the
// .json files at runtime — see this script's own comment for why.
const catalog = {
  account: {
    "deleteAccountModal.deleteAccount": "Delete Account",
    "deleteAccountModal.deleteYourAccount": "Delete Your Account?",
    "deleteAccountModal.deleting": "Deleting...",
    "deleteAccountModal.emailDoesNotMatchPleaseVerify": "Email does not match. Please verify and try again.",
    "deleteAccountModal.somethingWentWrongPleaseTryAgain": "Something went wrong. Please try again or contact support.",
    "deleteAccountModal.typeYourEmailToConfirm": "Type your email to confirm:",
    "deleteAccountModal.whatHappens": "What happens",
    "deleteAccountModal.signedOutNow": "You are signed out on every device now.",
    "deleteAccountModal.planEndsNow": "An active plan ends now. Refunds follow our refund rules: only within 3 days of payment, if the plan was not used.",
    "deleteAccountModal.deletedAfterSixMonths": "Your profile, lessons, answers, messages and progress are deleted for good after 6 months.",
    "deleteAccountModal.whatWeKeep": "What we keep, and why",
    "deleteAccountModal.keepPaymentRecord": "A record of each payment (date, amount, plan, your name and e-mail) for 10 years, for our accounts.",
    "deleteAccountModal.keepSupportCopies": "Copies of messages you sent to our support team, and our own records of actions on your account.",
    "deleteAccountModal.keepAnonymousNumbers": "Statistics that cannot identify you, such as AI usage and voice measurements without your name.",
    "deleteAccountModal.finalAfterSixMonths": "After 6 months the deletion cannot be undone.",
    "deleteAccountModal.changedYourMind": "Changed your mind? Sign in before {date} and choose Keep my account.",
    "pendingDeletion.title": "Your account is scheduled for deletion on {date}.",
    "pendingDeletion.titleNoDate": "Your account is scheduled for deletion.",
    "pendingDeletion.keepExplained": "If you keep your account, your lessons and progress stay as they are. A plan that ended when you asked for the deletion does not come back.",
    "pendingDeletion.keep": "Keep my account",
    "pendingDeletion.keeping": "Keeping your account...",
    "pendingDeletion.signOut": "Sign out",
    "pendingDeletion.kept": "Your account is active again.",
    "pendingDeletion.continue": "Continue",
    "pendingDeletion.closed": "This account has been closed. Contact contact@irtaki.net.",
    "pendingDeletion.graceOver": "The grace period is over; this account can no longer be kept.",
    "pendingDeletion.error": "Something went wrong. Please try again."
  },
  activities: {
    "elementPalette.earthBrown": "Earth Brown",
    "elementPalette.oliveGrove": "Olive Grove",
    "elementPalette.sageLeaf": "Sage Leaf",
    "elementPalette.sandstone": "Sandstone",
    "elementPalette.terracotta": "Terracotta",
    "errorSpotActivity.activityComplete": "Activity complete",
    "errorSpotActivity.attempt": "Attempt ",
    "errorSpotActivity.of3": " of 3",
    "errorSpotActivity.showMeWhere": "Show me where ›",
    "errorSpotActivity.tryAgain": "Try again",
    "errorSpotActivity.yourAnswer": "Your answer",
    "listeningSpotTheMismatchActivity.yourAnswer": "Your answer",
    "errorSpotActivity.whatShouldItSayInstead": "What should it say instead?",
    "flowFillActivity.activityComplete": "Activity complete",
    "flowFillActivity.allWordsPlaced": "All words placed.",
    "flowFillActivity.attempt": "Attempt ",
    "flowFillActivity.dragAWordFromTheBank": "Drag a word from the bank into each blank below. Tap ✕ on a filled blank to remove it and choose again.",
    "flowFillActivity.dropAWordHere": "Drop a word here",
    "flowFillActivity.of3": " of 3",
    "flowFillActivity.removeWord": "Remove {word}",
    "flowFillActivity.showMeWhere": "Show me where ›",
    "flowFillActivity.tryAgain": "Try again",
    "flowFillActivity.wordBank": "Word bank",
    "listeningActivityDispatcher.noRendererYetForActivityType": "No renderer yet for activity type “",
    "listeningApplyToNewScenarioActivity.activityComplete": "Activity complete",
    "listeningApplyToNewScenarioActivity.attempt": "Attempt ",
    "listeningApplyToNewScenarioActivity.of3": " of 3",
    "listeningApplyToNewScenarioActivity.options": "Options",
    "listeningApplyToNewScenarioActivity.tryAgain": "Try again",
    "listeningFlowCompletionActivity.activityComplete": "Activity complete",
    "listeningFlowCompletionActivity.attempt": "Attempt ",
    "listeningFlowCompletionActivity.chooseAWordBelow": "Choose a word below…",
    "listeningFlowCompletionActivity.of3": " of 3",
    "listeningFlowCompletionActivity.tryAgain": "Try again",
    "listeningFlowCompletionActivity.wordBank": "Word bank",
    "listeningListenAndGroupActivity.activityComplete": "Activity complete",
    "listeningListenAndGroupActivity.attempt": "Attempt ",
    "listeningListenAndGroupActivity.of3": " of 3",
    "listeningListenAndGroupActivity.tryAgain": "Try again",
    "listeningListenAndGroupActivity.zones": "Zones",
    "listeningMatchPairsActivity.activityComplete": "Activity complete",
    "listeningMatchPairsActivity.attempt": "Attempt ",
    "listeningMatchPairsActivity.leftCards": "Left cards",
    "listeningMatchPairsActivity.of3": " of 3",
    "listeningMatchPairsActivity.rightCards": "Right cards",
    "listeningMatchPairsActivity.tapACardOnTheLeft": "Tap a card on the left, then its match on the right.",
    "listeningMatchPairsActivity.tryAgain": "Try again",
    "listeningSpokenLinkIdentificationActivity.activityComplete": "Activity complete",
    "listeningSpokenLinkIdentificationActivity.attempt": "Attempt ",
    "listeningSpokenLinkIdentificationActivity.fb": " {fb}",
    "listeningSpokenLinkIdentificationActivity.leftCards": "Left cards",
    "listeningSpokenLinkIdentificationActivity.linkingWordForCard": "Linking word for {card}",
    "listeningSpokenLinkIdentificationActivity.of3": " of 3",
    "listeningSpokenLinkIdentificationActivity.rightCards": "Right cards",
    "listeningSpokenLinkIdentificationActivity.tapACardOnTheLeft": "Tap a card on the left, then its match on the right, then choose the linking word.",
    "listeningSpokenLinkIdentificationActivity.tryAgain": "Try again",
    "listeningSpokenLinkIdentificationActivity.whichWordLinksThisPair": "Which word links this pair?",
    "listeningSpotTheMismatchActivity.activityComplete": "Activity complete",
    "listeningSpotTheMismatchActivity.attempt": "Attempt ",
    "listeningSpotTheMismatchActivity.of3": " of 3",
    "listeningSpotTheMismatchActivity.tryAgain": "Try again",
    "listeningSpotTheMismatchActivity.whatShouldItSayInstead": "What should it say instead?",
    "listeningStatementSequencingActivity.activityComplete": "Activity complete",
    "listeningStatementSequencingActivity.attempt": "Attempt ",
    "listeningStatementSequencingActivity.dragToReorderText": "Drag to reorder: {text}",
    "listeningStatementSequencingActivity.moveDown": "Move down",
    "listeningStatementSequencingActivity.moveUp": "Move up",
    "listeningStatementSequencingActivity.of3": " of 3",
    "listeningStatementSequencingActivity.reorderableItems": "Reorderable items",
    "listeningStatementSequencingActivity.tryAgain": "Try again",
    "listeningTrueFalseRecallActivity.activityComplete": "Activity complete",
    "listeningTrueFalseRecallActivity.attempt": "Attempt ",
    "listeningTrueFalseRecallActivity.false": "False",
    "listeningTrueFalseRecallActivity.of3": " of 3",
    "listeningTrueFalseRecallActivity.true": "True",
    "listeningTrueFalseRecallActivity.trueOrFalse": "True or false",
    "listeningTrueFalseRecallActivity.tryAgain": "Try again",
    "listeningUnifiedClaimActivity.activityComplete": "Activity complete",
    "listeningUnifiedClaimActivity.attempt": "Attempt ",
    "listeningUnifiedClaimActivity.evaluationOptions": "Evaluation options",
    "listeningUnifiedClaimActivity.hedge": "Hedge",
    "listeningUnifiedClaimActivity.howShouldThisClaimBeHedged": "How should this claim be hedged?",
    "listeningUnifiedClaimActivity.justification": "Justification",
    "listeningUnifiedClaimActivity.of3": " of 3",
    "listeningUnifiedClaimActivity.tryAgain": "Try again",
    "listeningUnifiedClaimActivity.whichEvidenceBacksYourChoice": "Which evidence backs your choice?",
    "matchPairsActivity.activityComplete": "Activity complete",
    "matchPairsActivity.allOptionsPlaced": "All options placed.",
    "matchPairsActivity.attempt": "Attempt ",
    "matchPairsActivity.dragACardFromTheOptions": "Drag a card from the options below onto its match. Tap ✕ on a matched pair to remove it and choose again.",
    "matchPairsActivity.dropTheMatchingCardHere": "Drop the matching card here",
    "matchPairsActivity.matchingSlots": "Matching slots",
    "matchPairsActivity.of3": " of 3",
    "matchPairsActivity.options": "Options",
    "matchPairsActivity.removePairedtext": "Remove {pairedText}",
    "matchPairsActivity.showMeWhere": "Show me where ›",
    "matchPairsActivity.tryAgain": "Try again",
    "readingActivityDispatcher.noRendererYetForActivityType": "No renderer yet for activity type “",
    "replaySectionButton.replayThisPart": "▶ Replay this part",
    "sequenceOrderActivity.activityComplete": "Activity complete",
    "sequenceOrderActivity.attempt": "Attempt ",
    "sequenceOrderActivity.dragToReorderText": "Drag to reorder: {text}",
    "sequenceOrderActivity.moveDown": "Move down",
    "sequenceOrderActivity.moveUp": "Move up",
    "sequenceOrderActivity.of3": " of 3",
    "sequenceOrderActivity.reorderableClauses": "Reorderable clauses",
    "sequenceOrderActivity.reorderableItems": "Reorderable items",
    "sequenceOrderActivity.showMeWhere": "Show me where ›",
    "sequenceOrderActivity.tryAgain": "Try again",
    "singleSelectActivity.activityComplete": "Activity complete",
    "singleSelectActivity.attempt": "Attempt ",
    "singleSelectActivity.evaluationOptions": "Evaluation options",
    "singleSelectActivity.justification": "Justification",
    "singleSelectActivity.of3": " of 3",
    "singleSelectActivity.options": "Options",
    "singleSelectActivity.showMeWhere": "Show me where ›",
    "singleSelectActivity.tryAgain": "Try again",
    "singleSelectActivity.whichEvidenceBacksYourChoice": "Which evidence backs your choice?",
    "sortIntoZonesActivity.activityComplete": "Activity complete",
    "sortIntoZonesActivity.attempt": "Attempt ",
    "sortIntoZonesActivity.of3": " of 3",
    "sortIntoZonesActivity.showMeWhere": "Show me where ›",
    "sortIntoZonesActivity.tryAgain": "Try again",
    "sortIntoZonesActivity.zones": "Zones"
  },
  admin: {
    "actions.next": "Next",
    "adminAuditLog.admin": "Admin",
    "adminAuditLog.adminUid": "Admin UID...",
    "adminAuditLog.auditLog": "Audit Log",
    "adminAuditLog.changes": "Changes",
    "adminAuditLog.changesRecorded": "Changes recorded",
    "adminAuditLog.details": "Details",
    "adminAuditLog.entries": " entries",
    "adminAuditLog.log": "{log}",
    "adminAuditLog.noAdditionalDetails": "No additional details",
    "adminAuditLog.noAuditLogEntriesFound": "No audit log entries found",
    "adminAuditLog.of": " of ",
    "adminAuditLog.page": "Page ",
    "adminAuditLog.previous": "Previous",
    "adminAuditLog.previousStatus": "Previous Status",
    "adminAuditLog.reason": "Reason",
    "adminAuditLog.showing": "Showing ",
    "adminAuditLog.target": "Target",
    "adminAuditLog.to": " to ",
    "adminContent.edit": "Edit →",
    "adminContent.lessonLibrary": "Lesson Library",
    "adminContent.level": "Level",
    "adminContent.status": "Status",
    "adminContent.subject": "Subject",
    "adminContent.title": "Title",
    "adminContent.uploadContent": "Upload Content",
    "adminDashboard.dashboard": "Dashboard",
    "adminGatewayCredentials.gatewayCredentials": "Gateway Credentials",
    "adminGatewayCredentials.neverTested": "Never tested",
    "adminGatewayCredentials.notConfigured": "No key saved from this screen",
    "adminGatewayCredentials.saving": "Saving...",
    "adminGatewayCredentials.slickpaySTestConnectionCallIs": "SlickPay's test-connection call has never been verified against a live SlickPay account. A passing test here is weaker evidence than a passing Stripe test — do not read a green \"Configured\" badge as proof this integration actually works until it has been smoke-tested against a real sandbox transaction.",
    "adminGatewayCredentials.testConnection": "Test connection",
    "adminGatewayCredentials.testFailed": "Test failed",
    "adminGatewayCredentials.testing": "Testing...",
    "adminLayout.couldnTVerifyAdminAccessFor": "Couldn't verify admin access for this account. Please log in with an admin account and try again.",
    "adminLayout.notAuthorized": "Not authorized",
    "adminPayments.actions": "Actions",
    "adminPayments.amount": "Amount",
    "adminPayments.date": "Date",
    "adminPayments.gateway": "Gateway",
    "adminPayments.gatewayReference": "Gateway Reference",
    "adminPayments.noPaymentsFound": "No payments found",
    "adminPayments.of": " of ",
    "adminPayments.page": "Page ",
    "adminPayments.paymentDetails": "Payment Details",
    "adminPayments.paymentManagement": "Payment Management",
    "adminPayments.payments": " payments",
    "adminPayments.previous": "Previous",
    "adminPayments.searchByUserEmail": "Search by user email...",
    "adminPayments.showing": "Showing ",
    "adminPayments.status": "Status",
    "adminPayments.to": " to ",
    "adminPayments.user": "User",
    "adminPayments.userEmail": "User Email",
    "adminPayments.view": "View",
    "adminProblemReports.actions": "Actions",
    "adminProblemReports.attachment": "Attachment ",
    "adminProblemReports.attachments": "Attachments",
    "adminProblemReports.consoleLog": "Console log (",
    "adminProblemReports.description": "Description",
    "adminProblemReports.entries": " entries)",
    "adminProblemReports.files": "Files",
    "adminProblemReports.learner": "Learner",
    "adminProblemReports.noReportsFound": "No reports found",
    "adminProblemReports.of": " of ",
    "adminProblemReports.page": "Page ",
    "adminProblemReports.page_2": "Page",
    "adminProblemReports.previous": "Previous",
    "adminProblemReports.reportDetail": "Report detail",
    "adminProblemReports.reported": "Reported",
    "adminProblemReports.reportedScreenshot": "Reported screenshot",
    "adminProblemReports.reports": " reports",
    "adminProblemReports.screenshot": "Screenshot",
    "adminProblemReports.showing": "Showing ",
    "adminProblemReports.status": "Status",
    "adminProblemReports.tickets": "Tickets",
    "adminProblemReports.to": " to ",
    "adminProblemReports.view": "View",
    "adminRoles.actions": "Actions",
    "adminRoles.admin": "admin",
    "adminRoles.assign": "Assign",
    "adminRoles.assignARole": "Assign a role",
    "adminRoles.assigned": "Assigned",
    "adminRoles.assigning": "Assigning...",
    "adminRoles.by": "By",
    "adminRoles.consoleOnly": "Console only",
    "adminRoles.email": "Email",
    "adminRoles.findALearnerSUidVia": "Find a learner's UID via the Users page if they already have a profile.",
    "adminRoles.firebaseAuthUid": "Firebase Auth UID",
    "adminRoles.noAdminSupportUsersFound": "No admin/support users found",
    "adminRoles.noRoleRefusedEverywhere": "no role (refused everywhere)",
    "adminRoles.revoke": "Revoke",
    "adminRoles.role": "Role",
    "adminRoles.roles": "Roles",
    "adminRoles.superAdmin": "super_admin",
    "adminRoles.support": "support",
    "adminRoles.uid": "UID",
    "adminRoles.update": "Update",
    "adminRoles.userUid": "User UID",
    "adminSpecialties.addSpecialty": "+ Add Specialty",
    "adminSpecialties.addSpecialty_2": "Add Specialty",
    "adminSpecialties.displayName": "Display Name",
    "adminSpecialties.create": "Create",
    "adminSpecialties.creating": "Creating...",
    "adminSpecialties.eGComputerScience": "e.g. Computer Science",
    "adminSpecialties.hiddenNoLessonsYet": "Hidden — no lessons yet",
    "adminSpecialties.lessons": "Lessons",
    "adminSpecialties.noSpecialtiesYetAddTheFirst": "No specialties yet — add the first one above.",
    "adminSpecialties.slug": "Slug",
    "adminSpecialties.specialties": "Specialties",
    "adminSpecialties.status": "Status",
    "adminSpecialties.visibleToLearners": "Visible to learners",
    "adminSpecialties.wonTAppearInTheSignup": "Won't appear in the signup picker until lessons are uploaded for it.",
    "adminSubscriptions.alreadyRevoked": "Already revoked.",
    "adminSubscriptions.baseLessons": "Base lessons",
    "adminSubscriptions.block": "Block",
    "adminSubscriptions.blockExpires": "Block expires",
    "adminSubscriptions.blockLevel": "Block level",
    "adminSubscriptions.currentState": "Current state — ",
    "adminSubscriptions.findALearner": "Find a learner",
    "adminSubscriptions.grantAPlan": "Grant a plan",
    "adminSubscriptions.grantGrantplantype": "Grant {grantPlanType}",
    "adminSubscriptions.granting": "Granting...",
    "adminSubscriptions.lessonsDone": "Lessons done",
    "adminSubscriptions.monthly": "Monthly",
    "adminSubscriptions.noSubscriptionDocumentForThisLearner": "No subscription document for this learner.",
    "adminSubscriptions.plan": "Plan",
    "adminSubscriptions.planEndDate": "Plan end date",
    "adminSubscriptions.planType": "Plan type",
    "adminSubscriptions.requiredEGCompensationForA": "Required — e.g. compensation for a platform bug",
    "adminSubscriptions.requiredEGGrantedInError": "Required — e.g. granted in error, or abuse/chargeback",
    "adminSubscriptions.revokeImmediateBothPlans": "Revoke — immediate, both plans",
    "adminSubscriptions.revokeSubscription": "Revoke subscription",
    "adminSubscriptions.revokedAt": "Revoked at",
    "adminSubscriptions.revoking": "Revoking...",
    "adminSubscriptions.rolloverLessons": "Rollover lessons",
    "adminSubscriptions.searchByNameOrEmail": "Search by name or email...",
    "adminSubscriptions.status": "Status",
    "adminSubscriptions.subscriptions": "Subscriptions",
    "adminUsers.120Done": " / 120 done",
    "adminUsers.a1": "A1",
    "adminUsers.a2": "A2",
    "adminUsers.actions": "Actions",
    "adminUsers.addANote": "Add a note…",
    "adminUsers.placementReset": "Placement reset",
    "adminUsers.reasonOptionalKeptInThe": "Reason (optional, kept in the audit log)",
    "adminUsers.addNote": "Add note",
    "adminUsers.adding": "Adding...",
    "adminUsers.atBlock": "at block ",
    "adminUsers.avg": "avg ",
    "adminUsers.b1": "B1",
    "adminUsers.b2": "B2",
    "adminUsers.baseLessons": "Base lessons",
    "adminUsers.blockExpires": "Block expires",
    "adminUsers.blockLessons": "Block lessons",
    "adminUsers.blockProgress": "Block progress",
    "adminUsers.c1": "C1",
    "adminUsers.clearProgressReviewFlag": "Clear Progress Review Flag",
    "adminUsers.currentBlock": "Current block",
    "adminUsers.details": "Details",
    "adminUsers.eGLearnerDisputesTheirPlacement": "e.g. learner disputes their placement test result",
    "adminUsers.email": "Email",
    "adminUsers.escalate": "Escalate",
    "adminUsers.escalated": "Escalated",
    "adminUsers.escalatedForProgressReview": "Escalated for progress review",
    "adminUsers.flagged": "Flagged",
    "adminUsers.flaggedForProgressReview": "Flagged for progress review",
    "adminUsers.flaggedForProgressReviewOnly": "Flagged for progress review only",
    "adminUsers.flagged_2": "Flagged ",
    "adminUsers.lastActive": "Last Active",
    "adminUsers.lessons": "Lessons",
    "adminUsers.level": "Level",
    "adminUsers.confirmResetPlacement": "This wipes {name}'s current placement and re-locks all four skills (reading, listening, writing, speaking) at the level below. Any in-progress placement attempt is abandoned. This is a full re-placement, not a single-skill adjustment — use Override CEFR Level instead if only one skill needs correcting.",
    "adminUsers.defaultUserFallback": "this user",
    "adminUsers.name": "Name",
    "adminUsers.newCefrLevel": "New CEFR Level",
    "adminUsers.noUsersFound": "No users found",
    "adminUsers.of": " of ",
    "adminUsers.page": "Page ",
    "adminUsers.plan": "Plan",
    "adminUsers.planExpires": "Plan expires",
    "adminUsers.previous": "Previous",
    "adminUsers.processing": "Processing...",
    "adminUsers.progression": "Progression",
    "adminUsers.recentSessions": "Recent Sessions",
    "adminUsers.remaining": " remaining",
    "adminUsers.resetPlacement": "Reset Placement",
    "adminUsers.resetToResetplacementlevel": "Reset to {resetPlacementLevel}",
    "adminUsers.resetting": "Resetting...",
    "adminUsers.searchByNameOrEmail": "Search by name or email...",
    "adminUsers.showing": "Showing ",
    "adminUsers.skillS": "Skill(s): ",
    "adminUsers.status": "Status",
    "adminUsers.streak": "Streak",
    "adminUsers.subscription": "Subscription",
    "adminUsers.suspendUser": "Suspend User",
    "adminUsers.to": " to ",
    "adminUsers.trialExpires": "Trial expires",
    "adminUsers.trialLessons": "Trial lessons",
    "adminUsers.unsuspendUser": "Unsuspend User",
    "adminUsers.userDetails": "User Details",
    "adminUsers.userManagement": "User Management",
    "adminUsers.users": " users",
    "adminUsers.v": "(v",
    "superAdminGate.superAdminAccessRequired": "Super-admin access required",
    "superAdminGate.thisPageIsRestrictedToSuper": "This page is restricted to super-admins.",
    "adminGatewayCredentials.connected": "Connected",
    "adminGatewayCredentials.savedNotTested": "Saved, not tested yet",
    "adminGatewayCredentials.savedMeaning": "“Saved” only means a key was stored through this screen. It does not prove the key works. “Connected” appears only after Test connection makes a real, authenticated, read-only call to the payment provider and gets a success answer.",
    "adminGatewayCredentials.lastTest": "Last test {date}: {outcome}",
    "adminGatewayCredentials.lastTestOk": "passed (HTTP {status}, {mode} API)",
    "adminGatewayCredentials.lastTestFailed": "failed (HTTP {status}): {detail}",
    "adminGatewayCredentials.lastTestFailedNoStatus": "failed: {detail}",
    "adminGatewayCredentials.testPaymentTitle": "Test payment (100 DZD)",
    "adminGatewayCredentials.testPaymentBody": "Pays a real 100 DZD invoice with your own card through exactly the path a learner’s payment takes (same checks, same activation, same audit log), then shows what SlickPay answered. It grants your account 1 day of access and appears as TEST in Payments. Refunds are done in the SlickPay merchant dashboard.",
    "adminGatewayCredentials.testPaymentPhone": "Phone number SlickPay will see",
    "adminGatewayCredentials.testPaymentButton": "Pay 100 DZD (test)",
    "adminGatewayCredentials.testPaymentStarting": "Redirecting to SlickPay…",
    "adminGatewayCredentials.testPaymentPhoneInvalid": "Enter a valid phone number.",
    "adminGatewayCredentials.testPaymentFailed": "Could not start the test payment.",
    "adminGatewayCredentials.onHold": "On hold",
    "adminGatewayCredentials.stripeOnHoldNote": "Card payments (Stripe) are on hold: checkout is switched off, so nothing here is tested and no Stripe secret is read. Learners see “Card payment coming soon”. You can still save the keys now; they are only used once card checkout is switched on.",
    "adminGatewayCredentials.storedInSecret": "Stored in secret {secret}",
    "adminSlickPayTest.title": "SlickPay test payment",
    "adminSlickPayTest.intro": "What SlickPay really answered for your 100 DZD test invoice, checked by the same code that decides learners’ access.",
    "adminSlickPayTest.backToGateways": "Gateways",
    "adminSlickPayTest.thisPayment": "this payment",
    "adminSlickPayTest.checkAgain": "Check again",
    "adminSlickPayTest.checking": "Checking…",
    "adminSlickPayTest.checkFailed": "SlickPay could not be reached or answered unexpectedly just now. The values below are the last known ones.",
    "adminSlickPayTest.stateResolved": "Paid and activated",
    "adminSlickPayTest.statePending": "Not paid yet",
    "adminSlickPayTest.stateMismatch": "Paid but NOT verified",
    "adminSlickPayTest.stateBlocked": "Paid but not activated",
    "adminSlickPayTest.invoice": "SlickPay invoice",
    "adminSlickPayTest.reference": "Our reference",
    "adminSlickPayTest.expectedAmount": "Amount we asked for",
    "adminSlickPayTest.observedAmount": "Amount SlickPay reports",
    "adminSlickPayTest.transaction": "transaction",
    "adminSlickPayTest.noteMatch": "Note returned unchanged",
    "adminSlickPayTest.slickpayStatus": "SlickPay status read as",
    "adminSlickPayTest.anomalies": "Status values outside 0/1",
    "adminSlickPayTest.observedKeys": "Keys SlickPay sent (names only)",
    "adminSlickPayTest.refusedBecause": "Refused because",
    "adminSlickPayTest.activationBlocked": "Activation blocked",
    "adminSlickPayTest.lastError": "Last error",
    "adminSlickPayTest.activation": "Your subscription",
    "adminSlickPayTest.noSubscription": "No subscription yet",
    "adminSlickPayTest.until": "until",
    "adminSlickPayTest.appliedByThisPayment": "applied by this payment",
    "adminSlickPayTest.created": "Created",
    "adminSlickPayTest.lastChecked": "Last checked",
    "adminSlickPayTest.resolved": "Activated",
    "adminSlickPayTest.yes": "Yes",
    "adminSlickPayTest.no": "No",
    "adminSlickPayTest.none": "None",
    "adminSlickPayTest.notReported": "Not reported",
    "adminSubscriptionEditor.open": "Edit subscription…",
    "adminSubscriptionEditor.title": "Edit subscription",
    "adminSubscriptionEditor.plan": "Plan",
    "adminSubscriptionEditor.status": "Status",
    "adminSubscriptionEditor.keepPlan": "Keep current plan",
    "adminSubscriptionEditor.planTrial": "Trial",
    "adminSubscriptionEditor.planMonthly": "Monthly",
    "adminSubscriptionEditor.planBlock": "Level block (120 lessons, 365 days)",
    "adminSubscriptionEditor.planTest": "Test (1 day)",
    "adminSubscriptionEditor.statusAuto": "Automatic (from the dates)",
    "adminSubscriptionEditor.startDate": "Start date",
    "adminSubscriptionEditor.addDays": "Add / subtract days",
    "adminSubscriptionEditor.addDaysHint": "Moves the end date. A negative number that ends access before today makes the status expired.",
    "adminSubscriptionEditor.cancel": "Cancel the subscription now (access stops)",
    "adminSubscriptionEditor.preview": "Preview",
    "adminSubscriptionEditor.close": "Close",
    "adminSubscriptionEditor.previewTitle": "What will change",
    "adminSubscriptionEditor.before": "Before",
    "adminSubscriptionEditor.after": "After",
    "adminSubscriptionEditor.endDate": "End date",
    "adminSubscriptionEditor.daysLeft": "Days left",
    "adminSubscriptionEditor.lessons": "Lessons",
    "adminSubscriptionEditor.reason": "Reason (required, kept in the audit log)",
    "adminSubscriptionEditor.reasonHint": "Say why, e.g. “compensation for a failed payment”.",
    "adminSubscriptionEditor.reasonRequired": "A reason is required.",
    "adminSubscriptionEditor.apply": "Apply this change",
    "adminSubscriptionEditor.saved": "Subscription updated. The learner sees it the next time their app loads or regains focus.",
    "adminUsers.yes": "yes",
    "adminUsers.no": "no",
    "adminUsers.none": "none",
    "adminUsers.blockAttempt": "Block attempt",
    "adminUsers.sequenceProgress": "Lessons done (sequence)",
    "adminUsers.nextLessonPosition": "Next lesson",
    "adminUsers.lessonPosition": "Lesson {position}",
    "adminUsers.noNextLesson": "none (level finished)",
    "adminUsers.pendingOffer": "Pending retake offer",
    "adminUsers.gateWindowHeading": "Gate window (what the gate would judge today)",
    "adminUsers.gateWindowLine": "{qualifying} of {size} lessons at {bar} or more · {belowFloor} under 0.50 · mean {mean}",
    "adminUsers.gateWindowConditions": "Share ≥ 75 %: {share} · Tail ≤ 5 %: {tail} · Mean ≥ 0.50: {mean} · Counting rule: {met}",
    "adminUsers.gateWindowEmpty": "No lessons recorded in this block attempt yet.",
    "adminUsers.failedBlocks": "Failed blocks",
    "adminUsers.rungCap": "cap",
    "adminUsers.baseMean": "Base mean",
    "adminUsers.floorFlag": "floor flag",
    "adminUsers.placementCapped": "Placement capped (+2 range)",
    "adminUsers.placedServed": "{skill}: placed {placed}, served {served}",
    "adminUsers.r10Capped": "Capped by R10 (pilot safety net: writing and speaking may not exceed the higher of reading and listening by more than one level)",
    "adminUsers.r10Line": "{skill}: the test measured {raw}, placed {capped}",
    "adminUsers.dial": "Support dial",
    "adminUsers.dialWindow": "last scores",
    "adminUsers.dialUpStreak": "up-streak",
    "adminUsers.dialHint": "1 = most support, 4 = least. It goes down a step after a window mean under 0.50 and up a step after two windows at 0.85 or more; it resets to 2 when the level or block changes."
  },
  auth: {
    "mfaChallenge.title": "Two-step verification",
    "mfaChallenge.body": "Enter the 6-digit code from your authenticator app to finish signing in.",
    "mfaChallenge.codeLabel": "6-digit code",
    "mfaChallenge.verify": "Verify",
    "mfaChallenge.verifying": "Verifying…",
    "mfaChallenge.cancel": "Cancel and sign in again",
    "mfaChallenge.enterCode": "Enter the 6-digit code from your authenticator app.",
    "mfaChallenge.wrongCode": "That code is not correct. Check your authenticator app and try again ({left} tries left).",
    "mfaChallenge.tooManyWrong": "Too many incorrect codes. Please sign in again.",
    "mfaChallenge.sessionExpired": "This sign-in took too long and has expired. Please sign in again.",
    "mfaChallenge.noAuthenticator": "This account needs a second step that cannot be completed here. Please contact support.",
    "authError.enterEmailPassword": "Please enter your email and password.",
    "authError.incorrectCredentials": "Incorrect email or password. If you created your account with Google, use “Continue with Google” instead.",
    "authError.tooManyRequests": "Too many attempts. Please wait a few minutes and try again.",
    "authError.invalidEmail": "Please enter a valid email address.",
    "authError.popupClosed": "The sign-in window was closed before you finished. Please try again.",
    "authError.popupBlocked": "Your browser blocked the sign-in window. Please allow pop-ups for this site and try again.",
    "authError.network": "We could not reach the sign-in service. Check your internet connection and try again.",
    "authError.userDisabled": "This account has been closed. Contact contact@irtaki.net.",
    "authError.differentCredential": "An account with this email already exists using a different sign-in method. Try “Continue with Google”, or sign in with your email and password.",
    "authError.unauthorizedDomain": "Sign-in is not available on this web address. Please use the official EMI address.",
    "authError.generic": "Sign-in did not work. Please try again.",
    "emailSignUp.usesGoogle": "This email signs in with Google: use Continue with Google.",
    "emailSignUp.hasAccount": "You already have an account with this email: sign in or reset your password.",
    "emailSignUp.resetPassword": "Reset my password",
    "emailSignUp.disposable": "Please use a permanent email address. Temporary inbox addresses cannot be used.",
    "emailSignUp.weakPassword": "Use at least 8 characters for your password.",
    "emailSignUp.rateLimited": "Too many accounts were created from this connection. Please try again later.",
    "emailSignUp.alreadyConfirmed": "This address is already confirmed.",
    "emailSignUp.gmailUseGoogle": "This is a Gmail address: please use Continue with Google."
  },
  common: {
    "problemReporter.attachmentRules": "Attach an image, PDF or text file up to 10 MB",
    "pasteBlocked": "Type your answer - pasting is turned off",
    "list.separator": ", ",
    "actions.cancel": "Cancel",
    "actions.close": "Close",
    "actions.confirm": "Confirm",
    "actions.continue": "Continue",
    "actions.retry": "Retry",
    "theme.switchToDark": "Switch to dark mode",
    "theme.switchToLight": "Switch to light mode",
    "actions.submit": "Submit",
    "actions.tryAgain": "Try Again",
    "brandLockup.byIrtaki": "by Irtaki",
    "brandLockup.irtaki": "Irtaki",
    "cefrLevelLabels.a1": "Beginner (A1)",
    "cefrLevelLabels.a2": "Elementary (A2)",
    "cefrLevelLabels.b1": "Intermediate (B1)",
    "cefrLevelLabels.b2": "Upper-Intermediate (B2)",
    "cefrLevelLabels.c1": "Advanced (C1)",
    "configHealthBanner.firebaseAuthIsMisconfiguredSignIn": "Firebase Auth is misconfigured — sign-in will not work. (",
    "configHealthBanner.unknownFirebaseAuthMisconfiguration": "Unknown Firebase Auth misconfiguration.",
    "loadingSpinner.loading": "Loading",
    "navigation.home": "Home",
    "navigation.profile": "Profile",
    "navigation.messages": "Messages",
    "legal.privacyPolicy": "Privacy Policy",
    "legal.termsOfUse": "Terms of Use",
    "legal.consentLine": "By continuing you agree to our Terms of Use and Privacy Policy.",
    "navigation.upgrade": "Upgrade",
    "problemReporter.aScreenshotOfThisScreenNot": "A screenshot of this screen (not including the report button itself)",
    "problemReporter.andNameDisplayname": " and name ({displayName})",
    "problemReporter.andThePageYouReOn": " and the page you're on",
    "problemReporter.attachFilesOptionalUpTo": "Attach files (optional, up to ",
    "problemReporter.attachedFileCount_one": "{count} attached file",
    "problemReporter.attachedFileCount_other": "{count} attached files",
    "problemReporter.thanksWeLlTakeALook": "Sent. We'll reply in your Messages.",
    "problemReporter.couldNotSendThisReport": "Could not send this report. Try again.",
    "problemReporter.signInAgain": "You were signed out. Please sign in again, then send your report.",
    "problemReporter.tooManyRequests": "Too many requests right now. Please wait a minute and press Send report again.",
    "problemReporter.noScreenshotThisTime": "No screenshot this time (your browser could not capture one) — your description and recent console log are still sent",
    "problemReporter.sentWithoutSomeFiles": "Your report was sent, but some files could not be uploaded. We have your description and can ask you for them if needed.",
    "problemReporter.beforeYouSendThis": "Before you send this",
    "problemReporter.capturedScreenshotPreview": "Captured screenshot preview",
    "problemReporter.reportAProblem": "Report a problem",
    "problemReporter.sendReport": "Send report",
    "problemReporter.thisReportWillInclude": "This report will include:",
    "problemReporter.weStripAnythingThatLooksLike": "We strip anything that looks like a login token before sending, but avoid attaching anything you wouldn't want us to see.",
    "problemReporter.whatHappened": "What happened?",
    "problemReporter.yourAccountEmail": "Your account email",
    "problemReporter.yourRecentConsoleLogThisIs": "Your recent console log — this is what actually shows us what went wrong, instead of guessing",
    "status.loading": "Loading...",
    "toast.dismiss": "Dismiss",
    "problemReporter.screenshotThumbLabel": "This picture of your screen will be attached. You can remove it.",
    "problemReporter.removeScreenshot": "Remove the picture",
    "problemReporter.openMessages": "Open Messages",
    "legal.refunds": "Refunds and cancellation",
    "warming.gettingReady": "Getting things ready…",
    "table.scrollHint": "Scroll sideways to see the whole table",
    "table.frameLabel": "Table, scrolls sideways"
  },
  errors: {
    "aiError.ai_timeout": "The AI service timed out. Please try submitting again.",
    "aiError.auth": "AI service configuration error. Please contact support.",
    "aiError.invalid_response": "AI returned an unexpected response. Please try again.",
    "aiError.json_extract_failed": "AI returned an unexpected response. Please try again.",
    "aiError.quota_exceeded": "Daily AI usage limit reached. Please try again tomorrow.",
    "aiError.rate_limit": "AI provider rate limit reached. Please wait a moment and try again.",
    "aiError.safety": "Your submission was flagged by content policy. Please try again.",
    "aiError.unsupported_task_type": "Internal AI configuration error.",
    "aiError.generic": "AI evaluation failed. Please try again.",
    "api.accountDeletionPartialFailure": "Account deletion completed with errors. Some data may not have been fully deleted. Please contact support if issues persist.",
    "api.activityAlreadyFinalised": "That activity was already submitted.",
    "api.activityDataInvalid": "This activity's data is invalid. Please refresh and try again.",
    "api.activityNotFound": "That activity couldn't be found.",
    "api.activityNotInSelection": "That activity isn't part of the current set.",
    "api.evalInsufficientAttempts": "Complete all the activities before submitting.",
    "api.evalInvalidStatus": "This step isn't available right now. Please refresh and try again.",
    "api.generic": "Something went wrong. Please try again, or contact support if this continues.",
    "api.lessonSpecNotFound": "This lesson's content couldn't be found.",
    "api.notAuthorized": "You're not authorized to do that.",
    "api.scaffoldingAlreadyCompleted": "This part of the lesson is already complete.",
    "api.scaffoldingAlreadyStarted": "This part of the lesson has already started.",
    "api.scaffoldingNotStarted": "This part of the lesson hasn't started yet. Please refresh and try again.",
    "api.sessionNotFound": "We couldn't find that lesson session.",
    "api.sessionNotInProgress": "This lesson session is no longer in progress.",
    "api.stage4InvalidStatus": "This step isn't available right now. Please refresh and try again.",
    "api.submissionRequiresCorrections": "Please review and correct your answer before submitting.",
    "api.turnNotFound": "That conversation turn couldn't be found.",
    "api.vocabLookupFailed": "Couldn't load this definition. Please try again.",
    "api.noPendingRetakeOffer": "This session doesn't have a pending retake offer.",
    "api.readingPhaseNotComplete": "Complete the Reading phase before starting Listening.",
    "api.activitySessionMismatch": "That activity doesn't belong to this lesson session.",
    "api.readingListeningNotComplete": "Complete the Reading and Listening phases before starting Writing.",
    "api.stemCompletionsRequired": "This task uses sentence starters — please complete them instead of writing free text.",
    "api.stemCompletionsCountMismatch": "Please complete all {expected} sentence starters (you submitted {got}).",
    "api.textSubmissionRequired": "This task doesn't use sentence starters — please write your answer as free text.",
    "api.sessionAlreadyCompleted": "This lesson session is already complete.",
    "api.listeningPhaseNotComplete": "Complete the Listening phase before starting Writing.",
    "api.writingPhaseNotComplete": "Complete the Writing phase before starting Speaking.",
    "api.sessionAbandoned": "This lesson session was abandoned and can't be completed.",
    "api.lessonNotFound": "We couldn't find that lesson.",
    "apiLoadingState.almostThere": "Almost there...",
    "apiLoadingState.readingYourAnswer": "Reading your answer...",
    "apiLoadingState.thinkingAboutThis": "Thinking about this...",
    "apiProxy.notAuthenticated": "Not authenticated",
    "apiProxy.ttsFailed": "TTS failed",
    "apiTimeoutError.attempt": "Attempt ",
    "apiTimeoutError.completedPhases": "Completed phases:",
    "apiTimeoutError.goToLessonHome": "Go to Lesson Home",
    "apiTimeoutError.of3": " of 3",
    "apiTimeoutError.phase": "Phase ",
    "apiTimeoutError.reportAProblem": "Report a problem →",
    "apiTimeoutError.saveAndExit": "Save and Exit",
    "apiTimeoutError.somethingIsWrongOnOurSide": "Something is wrong on our side.",
    "apiTimeoutError.theAiTutorIsTakingToo": "The AI tutor is taking too long to respond.",
    "apiTimeoutError.yourProgressHasBeenSaved": "Your progress has been saved.",
    "apiTimeoutError.yourProgressIsSavedYouCan": "Your progress is saved — you can come back to this lesson later.",
    "audioFallback.audioNotAvailableRightNow": "Audio not available right now.",
    "audioFallback.readTranscript": "Read Transcript",
    "audioFallback.readingTranscript": "Reading transcript",
    "audioFallback.youCanReadTheTranscriptInstead": "You can read the transcript instead.",
    "errorBoundary.anUnexpectedErrorOccurred": "An unexpected error occurred.",
    "errorBoundary.somethingWentWrong": "Something went wrong",
    "errorBoundary.tryAgain": "Try again",
    "gate.accountSuspended": "Your account is suspended. Please contact support.",
    "gate.blockExhausted": "You've finished this block. To keep learning, buy the {level} block.",
    "gate.blockExpired": "Your block access has ended. Purchase again to keep learning.",
    "gate.courseCompleted": "You've completed every level this course offers. There are no more lessons to start.",
    "gate.dailyLimitReached": "Daily trial limit reached. Come back tomorrow or upgrade now!",
    "gate.generic": "This lesson isn't available right now. Please try again, or contact support if this continues.",
    "gate.lessonDone": "Activities aren't available — they ran once, during your original attempt.",
    "gate.lessonInProgress": "You have a lesson in progress. Finish it or abandon it before starting another.",
    "gate.lessonNotPublished": "This lesson is not yet available.",
    "gate.lessonNotUnlocked": "Finish lesson {position} first.",
    "api.phaseIncomplete": "Answer every question to finish this part.",
    "api.sessionIncomplete": "Finish every part of the lesson first.",
    "gate.retakeOfferPending": "You have a lesson waiting to be redone. Redo it, or skip the redo, before you start another lesson.",
    "gate.retakePhaseLocked": "This part is not one of the parts you were offered to redo. You can only redo the parts you were offered.",
    "gate.levelMismatch": "This lesson isn't available at your current placement level.",
    "gate.noSubscription": "No active subscription. Complete placement test to activate your trial.",
    "gate.placementIncomplete": "Finish your placement test before starting a lesson — {skills} still needs to be measured.",
    "gate.planExpired": "Your monthly plan has ended. Renew to keep learning.",
    "gate.planLimitReached": "Plan limit reached ({used}/{total}). Renew to keep learning.",
    "gate.progressReviewRequired": "Your progress needs a look from your instructor. You'll be contacted via the email you provided when creating this account.",
    "gate.subscriptionCancelled": "Your subscription has been cancelled.",
    "gate.subscriptionExpired": "Your subscription has expired. Please renew to continue.",
    "gate.subscriptionRevoked": "Your access was revoked by an administrator. Contact support if you believe this is a mistake.",
    "gate.trialExpired": "Your 10-day trial period has ended. Upgrade to keep learning.",
    "gate.trialLimitReached": "Trial limit reached ({used}/{total}). Upgrade to keep learning.",
    "micPermissionError.connectAMicrophoneToYourDevice": "Connect a microphone to your device to use speaking practice.",
    "micPermissionError.continueWithTextInstead": "Continue with text instead",
    "micPermissionError.iVeAllowedItTryAgain": "I've allowed it — try again",
    "micPermissionError.noMicrophoneFound": "No microphone found.",
    "micPermissionError.stillBlockedPleaseFollowTheBrowser": "Still blocked — please follow the browser instructions above or use the text option.",
    "micPermissionError.yourMicrophoneIsBlocked": "Your microphone is blocked.",
    "networkOfflineBanner.noInternetConnection": "No internet connection",
    "speakingUnavailableError.finishLesson": "Finish Lesson",
    "speakingUnavailableError.speakingPracticeIsnTAvailableYet": "Speaking practice isn't available yet.",
    "speakingUnavailableError.yourReadingListeningAndWritingProgress": "Your reading, listening, and writing progress is saved. Come back to speaking practice later.",
    "subscriptionExpiryBanner.finishLesson": "Finish Lesson",
    "subscriptionExpiryBanner.viewPlans": "View Plans",
    "subscriptionExpiryBanner.youCanFinishThisLessonThen": "You can finish this lesson, then choose a plan to continue.",
    "subscriptionExpiryBanner.yourSubscriptionHasEnded": "Your subscription has ended.",
    "useSentenceTts.ttsPlaybackFailed": "TTS playback failed",
    "api.rateLimited": "You're going a little fast. Please wait a moment and try again.",
    "rateLimit.notice": "Too many requests at once. Please wait {seconds}s, then try again.",
    "rateLimit.ready": "You can try again now.",
    "rateLimit.dismiss": "Dismiss",
    "gate.blockExhaustedNoLevel": "You've finished this block. Purchase the next block to continue.",
    "gate.lessonNotUnlockedNone": "You have finished every lesson in this level.",
    "errorBoundary.appUpdated": "The app was updated while this page was open. Reload the page to continue where you were.",
    "errorBoundary.reloadPage": "Reload the page",
    "api.firstAnswerRequired": "Type your first answer; speaking opens after it.",
    "api.speakingRequired": "The typed practice is done. Answer by speaking with the microphone.",
    "api.vocabStepRequired": "Match the words first. Listening opens after that.",
    "api.vocabPairsInvalid": "Match every word to one meaning, then check.",
    "api.vocabStepOutOfSync": "This step has already moved on. Reload the page to continue."
  },
  lesson: {
    "audioPlayer.audioNotAvailable": "Audio not available",
    "audioPlayer.hide": "Hide",
    "audioPlayer.hideTranscript": "Hide transcript",
    "audioPlayer.readTranscript": "Read Transcript",
    "audioPlayer.transcript": "Transcript",
    "audioPlayer.x": "x",
    "blockOutcomeCopy.advance.body": "You've completed {fromBlock} and moved up to {toBlock}. To start your {toBlock} lessons, buy the {toBlock} block.",
    "blockOutcomeCopy.advance.heading": "Block Complete!",
    "blockOutcomeCopy.dropped.body": "Your scores across all four skills fell below what's needed to stay at {fromBlock}, so you've moved down to {toBlock}. This resets your progress window, but the skills you've built stay with you — keep practicing and you'll work back up.",
    "blockOutcomeCopy.dropped.heading": "You've Moved Down to {toBlock}",
    "blockOutcomeCopy.masteredAtCeiling.body": "Congratulations — your scores have cleared every requirement at C1, the highest level this course teaches.",
    "blockOutcomeCopy.masteredAtCeiling.heading": "You've Mastered C1",
    "blockOutcomeCopy.redo.body": "Your scores in {fromBlock} didn't clear the bar to move up, so you'll repeat this level's lessons from lesson 1. Starting the repeat needs a new block purchase.",
    "blockOutcomeCopy.redo.heading": "You'll Repeat This Block",
    "blockProgressPopup.blockProgress": "Block Progress",
    "completionBands.listening.belowThreshold.A1": "Some of these words are new to you. Listen to the recording again. This will help you learn them.",
    "completionBands.listening.belowThreshold.A2": "Some parts of this listening practice were difficult. Listen to them again — you are improving.",
    "completionBands.listening.belowThreshold.B1": "You've finished this listening practice. A few ideas need another look — review the highlighted parts and try again.",
    "completionBands.listening.belowThreshold.B2": "You've finished this listening practice. A couple of points didn't quite land — revisit them to close the gap.",
    "completionBands.listening.belowThreshold.C1": "You've finished this listening practice. A few nuances slipped past you this time — reviewing them will sharpen your grasp of dense academic material.",
    "completionBands.listening.solid.A1": "You understood the main ideas. Practice a little more to get even better.",
    "completionBands.listening.solid.A2": "You understood more of this listening practice each time. Practice a little more, then try another lesson.",
    "completionBands.listening.solid.B1": "You understood the key ideas in this listening practice well. A little more practice will help before you try a harder recording.",
    "completionBands.listening.solid.B2": "Good comprehension across this listening practice. A bit more practice will help you consolidate it — consider a longer recording next.",
    "completionBands.listening.solid.C1": "This is a strong demonstration of comprehension, though further practice would help you consolidate it before moving to denser academic material.",
    "completionBands.listening.strong.A1": "You understood the main ideas. This is good. You are ready for the next recording.",
    "completionBands.listening.strong.A2": "You understood more of this listening practice than before. You are ready for the next lesson.",
    "completionBands.listening.strong.B1": "You understood the key ideas in this listening practice well. You're ready for a more difficult recording when you want to continue.",
    "completionBands.listening.strong.B2": "Your comprehension across this listening practice was strong throughout. Consider moving on to a longer or more complex recording.",
    "completionBands.listening.strong.C1": "This is a strong demonstration of comprehension. You're ready for denser academic material.",
    "completionBands.listening.struggledHard.A1": "This listening practice was hard. These words are new to you. Try again. Every try helps you learn.",
    "completionBands.listening.struggledHard.A2": "This listening practice was hard. Some parts were difficult. Listen to them again. Every try helps you learn.",
    "completionBands.listening.struggledHard.B1": "This listening practice was challenging, and several ideas need another look. That's normal when working with harder material — review the highlighted parts and try again.",
    "completionBands.listening.struggledHard.B2": "This listening practice was challenging, and several points didn't quite land. That's expected with more demanding recordings — revisit them and you'll close the gap.",
    "completionBands.listening.struggledHard.C1": "This listening practice was challenging, and a number of nuances slipped past you this time. That's to be expected with dense academic material — reviewing them will sharpen your grasp of it.",
    "completionBands.reading.belowThreshold.A1": "Some of these words are new to you. Read the text again. This will help you learn them.",
    "completionBands.reading.belowThreshold.A2": "Some parts of this reading were difficult. Read them again — you are improving.",
    "completionBands.reading.belowThreshold.B1": "You've finished this reading. A few ideas need another look — review the highlighted parts and try again.",
    "completionBands.reading.belowThreshold.B2": "You've finished this reading. A couple of points didn't quite land — revisit them to close the gap.",
    "completionBands.reading.belowThreshold.C1": "You've finished this reading. A few nuances slipped past you this time — reviewing them will sharpen your grasp of dense academic passages.",
    "completionBands.reading.solid.A1": "You understood the main ideas. Practice a little more to get even better.",
    "completionBands.reading.solid.A2": "You understood more of this reading each time. Practice a little more, then try another lesson.",
    "completionBands.reading.solid.B1": "You understood the key ideas in this reading well. A little more practice will help before you try a harder text.",
    "completionBands.reading.solid.B2": "Good comprehension across this reading. A bit more practice will help you consolidate it — consider a longer text next.",
    "completionBands.reading.solid.C1": "This is a strong demonstration of comprehension, though further practice would help you consolidate it before moving to denser academic material.",
    "completionBands.reading.strong.A1": "You understood the main ideas. This is good. You are ready for the next text.",
    "completionBands.reading.strong.A2": "You understood more of this reading than before. You are ready for the next lesson.",
    "completionBands.reading.strong.B1": "You understood the key ideas in this reading well. You're ready for a more difficult text when you want to continue.",
    "completionBands.reading.strong.B2": "Your comprehension across this reading was strong throughout. Consider moving on to a longer or more complex text.",
    "completionBands.reading.strong.C1": "This is a strong demonstration of comprehension. You're ready for denser academic material.",
    "completionBands.reading.struggledHard.A1": "This reading was hard. These words are new to you. Try again. Every try helps you learn.",
    "completionBands.reading.struggledHard.A2": "This reading was hard. Some parts were difficult. Look at them again. Every try helps you learn.",
    "completionBands.reading.struggledHard.B1": "This reading was challenging, and several ideas need another look. That's normal when working with harder material — review the highlighted parts and try again.",
    "completionBands.reading.struggledHard.B2": "This reading was challenging, and several points didn't quite land. That's expected with more demanding texts — revisit them and you'll close the gap.",
    "completionBands.reading.struggledHard.C1": "This reading was challenging, and a number of nuances slipped past you this time. That's to be expected with dense academic material — reviewing them will sharpen your grasp of it.",
    "courseCompletedScreen.congratulationsYourScoresHaveClearedEvery": "Congratulations — your scores have cleared every requirement at C1, the highest level this course teaches.",
    "courseCompletedScreen.thereAreNoMoreLessonsIn": "There are no more lessons in this course — you've completed all of them.",
    "courseCompletedScreen.youVeMasteredC1": "You've Mastered C1",
    "expandableIllustration.altClickToEnlarge": "{alt} — click to enlarge",
    "expandableIllustration.clickToEnlarge": "Click to enlarge",
    "expandableIllustration.zoomIn": "Zoom in",
    "expandableIllustration.zoomOut": "Zoom out",
    "expandableIllustration.dragToPanWhenZoomedIn": "Drag to look around",
    "lessonCard.completed": "Completed ✓",
    "lessonCard.min": " min",
    "lessonCompletionPage.backToHome": "Back to Home",
    "lessonCompletionPage.chooseAPlan": "Choose a Plan",
    "lessonCompletionPage.greatWorkFinishingYourLessonChoose": "Great work finishing your lesson! Choose a plan to continue learning.",
    "lessonCompletionPage.lessonComplete": "Lesson Complete!",
    "lessonCompletionPage.next": "Next: ",
    "lessonCompletionPage.vocabularyProgress": "Vocabulary Progress",
    "lessonHomePage.accountSuspended": "Account Suspended",
    "lessonHomePage.checkBackSoon": "Check back soon!",
    "lessonHomePage.completeYourProfileToSeeLessons": "Complete your profile to see lessons for your field.",
    "lessonHomePage.contactSupport": "Contact Support",
    "lessonHomePage.freeTrialLessonsRemaining_one": "{count} free trial lesson remaining",
    "lessonHomePage.freeTrialLessonsRemaining_other": "{count} free trial lessons remaining",
    "lessonHomePage.defaultLearnerName": "Learner",
    "lessonHomePage.hello": "Hello, {name}",
    "lessonHomePage.noLessonsAvailableYet": "No lessons available yet.",
    "lessonHomePage.noSpecialtySelectedYet": "No specialty selected yet.",
    "lessonHomePage.readyForTodaySLesson": "Ready for today's lesson?",
    "lessonHomePage.subscribeToContinue": "Subscribe to continue →",
    "lessonHomePage.yourAccountHasBeenSuspendedPlease": "Your account has been suspended. Please contact support for assistance.",
    "lessonHomePage.yourTrialHasEnded": "Your trial has ended.",
    "lessonHomePage.yourPlanHasEnded": "Your plan has ended.",
    "lessonPage.backToHome": "Back to Home",
    "lessonPage.failedToLoadLesson": "Failed to load lesson.",
    "lessonPage.failedToFinishLesson": "We couldn't finish the lesson. Please try again.",
    "lessonPage.tryAgain": "Try again",
    "lessonPage.invalidSessionOrSpecResponse": "Invalid session or spec response",
    "lessonPage.writeAboutTheTopic": "Write about the topic.",
    "lessonReviewScreen.backToHome": "Back to Home",
    "lessonReviewScreen.listening": "Listening",
    "lessonReviewScreen.reading": "Reading",
    "lessonReviewScreen.theTextAndAudioAreHere": "The text and audio are here anytime to review. Activities aren't available — they ran once, during your original attempt.",
    "lessonReviewScreen.youVeCompletedThisLesson": "You've completed this lesson",
    "lessonScoreSummary.practiceOnly": "Practice only",
    "lessonScoreSummary.notCompleted": "Not completed",
    "lessonScoreSummary.overall": "Overall",
    "lessonScoreSummary.performanceAt": "Performance at",
    "lessonScoreSummary.performanceLabel.excellent": "Excellent",
    "lessonScoreSummary.performanceLabel.good": "Good",
    "lessonScoreSummary.performanceLabel.keepPracticing": "Keep Practicing",
    "lessonScoreSummary.performanceLabel.needsWork": "Needs Work",
    "lessonScoreSummary.scoresAreWeightedAcrossAllPhases": "Scores are weighted across all phases. Focus on areas that need work in your next lesson.",
    "lessonScoreSummary.skillBreakdown": "Skill Breakdown",
    "levelUpNotification.cefrLabel.a1": "Beginner",
    "levelUpNotification.cefrLabel.a2": "Elementary",
    "levelUpNotification.cefrLabel.b1": "Intermediate",
    "levelUpNotification.cefrLabel.b2": "Upper Intermediate",
    "levelUpNotification.cefrLabel.c1": "Advanced",
    "levelUpNotification.headingLevelUp": "Level Up!",
    "levelUpNotification.headingLevelUpdate": "Level Update",
    "levelUpNotification.levelMovedDown": "Level moved down",
    "levelUpNotification.multiSkillDown": "{count} of your skills moved down a level. Keep practising — you'll build them back up.",
    "levelUpNotification.multiSkillUp": "Amazing progress — you've advanced in {count} skills!",
    "levelUpNotification.oneSkillDown": "Your {skill} level moved down to {level}. Keep practising — you'll build it back up.",
    "levelUpNotification.oneSkillUp": "Your {skill} skills have reached a new level!",
    "levelUpNotification.skillName.listening": "Listening",
    "levelUpNotification.skillName.reading": "Reading",
    "levelUpNotification.skillName.speaking": "Speaking",
    "levelUpNotification.skillName.writing": "Writing",
    "listeningAudioPlayer.5s": "−5s",
    "listeningAudioPlayer.5s_2": "+5s",
    "listeningAudioPlayer.audioNotAvailable": "Audio not available",
    "listeningAudioPlayer.audioPosition": "Audio position",
    "listeningAudioPlayer.back5Seconds": "Back 5 seconds",
    "listeningAudioPlayer.cc": "CC",
    "listeningAudioPlayer.forward5Seconds": "Forward 5 seconds",
    "listeningAudioPlayer.pause": "Pause",
    "listeningAudioPlayer.play": "Play",
    "listeningAudioPlayer.playFullDialogue": "Play full dialogue",
    "listeningAudioPlayer.turnCaptionsOff": "Turn captions off",
    "listeningAudioPlayer.turnCaptionsOn": "Turn captions on",
    "phase1Listening.backToLessons": "Back to lessons",
    "phase1Listening.lessonIllustrationI1": "Lesson illustration {i1}",
    "phase1Listening.score": "Score: ",
    "phase1Listening.tryAgain": "Try again",
    "phase1Listening.practiceOnly": "Listen to the dialogue as many times as you like. There are no questions for this part today, so it is not scored.",
    "phase2Reading.practiceOnly": "Read the text as long as you like. There are no questions for this part today, so it is not scored.",
    "phase1Listening.weHitASnagLoadingThe": "We hit a snag loading the next part of this lesson — nothing about your work here was lost. Let's head back and pick up fresh.",
    "phase1Listening.failedToLoadListeningActivities": "Failed to load listening activities",
    "phase1Listening.failedToRecordYourAnswer": "Failed to record your answer",
    "phase2Reading.backToLessons": "Back to lessons",
    "phase2Reading.continueToComprehensionQuestions": "Continue to Comprehension Questions",
    "phase2Reading.continueToPhase2Listening": "Continue to Phase 2 (Listening)",
    "phase2Reading.decreaseTextSize": "Decrease text size",
    "phase2Reading.increaseTextSize": "Increase text size",
    "phase2Reading.lessonIllustrationI1": "Lesson illustration {i1}",
    "phase2Reading.score": "Score: ",
    "phase2Reading.tryAgain": "Try again",
    "phase2Reading.weHitASnagLoadingThe": "We hit a snag loading the next part of this lesson — nothing about your work here was lost. Let's head back and pick up fresh.",
    "phase2Reading.failedToLoadComprehensionQuestions": "Failed to load comprehension questions",
    "phase2Reading.failedToRecordYourAnswer": "Failed to record your answer",
    "phase3Writing.cannotSubmitWhileOffline": "Cannot submit while offline. Your draft has been saved locally.",
    "phase3Writing.continueToSpeaking": "Continue to Speaking",
    "phase3Writing.minTaskdata": " / minimum {taskData}",
    "phase3Writing.reviseMyResponse": "Revise my response",
    "phase3Writing.reviseToContinue": "Revise your text and submit it again to go on to speaking.",
    "phase3Writing.submissionFailed": "Submission failed.",
    "phase3Writing.submitForFeedback": "Submit for Feedback",
    "phase3Writing.submitNeedsMoreWords_one": "Write {count} more word to send your answer (the minimum is {min} words).",
    "phase3Writing.submitNeedsMoreWords_other": "Write {count} more words to send your answer (the minimum is {min} words).",
    "phase3Writing.submitNeedsStems": "Each sentence needs at least {min} words before you can send your answer.",
    "phase3Writing.wordCount_one": "{count} word",
    "phase3Writing.wordCount_other": "{count} words",
    "phase4Speaking.alexAudioUnavailableTextOnlyMode": "Alex audio unavailable — text-only mode for this session",
    "phase4Speaking.alexIsThinking": "Alex is thinking…",
    "phase4Speaking.havingTroubleWithAudio": "Having trouble with audio?",
    "phase4Speaking.minTurnsNoteComplete": "Finish whenever you like.",
    "phase4Speaking.alexWrappedUp": "Alex has wrapped up the conversation. Press Finish to see how it went.",
    "phase4Speaking.mustSpeak": "Typing practice is done. Now answer by speaking: {done} of {needed} spoken answers.",
    "phase4Speaking.micProblemTyping": "Your microphone is not working, so you can type your answers. We have noted this.",
    "phase4Speaking.introTitle": "Before you start",
    "phase4Speaking.introUseWords": "Use these words in your answers to meet the task's objectives.",
    "phase4Speaking.introTapStart": "Tap Start to hear Alex and begin.",
    "phase4Speaking.startConversation": "Start the conversation",
    "phase4Speaking.starting": "Starting...",
    "phase4Speaking.soundBlocked": "Your browser is blocking Alex's sound.",
    "phase4Speaking.tapToHear": "Tap to hear Alex",
    "speakingRecapPanel.remediationTitle": "How to meet the objectives next time",
    "speakingRecapPanel.remediationIntro": "The conversation ended before you covered everything the task asked for. Next time:",
    "speakingRecapPanel.remediationAnswer": "Answer Alex's question directly. Say your answer first, then add a reason or an example.",
    "speakingRecapPanel.remediationFocus": "Keep to the point. Stay on the topic of the question; do not move to another subject.",
    "speakingRecapPanel.remediationWords": "Use the target words in your answers. You did not use:",
    "phase4Speaking.minTurnsNoteContinue": "Talk with Alex, then finish when you're ready.",
    "phase4Speaking.failedToFinish": "We couldn't finish this part. Please try again.",
    "phase4Speaking.progress": "Progress",
    "phase4Speaking.recordingStoppedNothingWasDetectedTap": "Recording stopped — nothing was detected. Tap the mic to try again.",
    "phase4Speaking.replyToAlex": "Reply to Alex…",
    "phase4Speaking.moodAndFeedback": "Alex's mood and feedback",
    "phase4Speaking.send": "Send",
    "phase4Speaking.switchToText": "Switch to text",
    "phase4Speaking.thatWasTooShortTryTo": "That was too short — try to give a fuller answer.",
    "phase4Speaking.theSituation": "The situation",
    "phase4Speaking.turn": "Turn ",
    "phase4Speaking.useTextInstead": "Use text instead",
    "phase4Speaking.weReNotHearingAnythingIs": "We're not hearing anything — is your mic working?",
    "phase4Speaking.whoAmI": "Who am I?",
    "phase4Speaking.yourPausedRecordingWasDiscardedAfter": "Your paused recording was discarded after sitting untouched — tap the mic to start again.",
    "phaseLabels.complete": "✓ Complete",
    "phaseLabels.listening": "Phase 2",
    "phaseLabels.reading": "Phase 1",
    "phaseLabels.speaking": "Phase 4",
    "phaseLabels.writing": "Phase 3",
    "progressReviewScreen.aQuickPause": "A Quick Pause",
    "progressReviewScreen.yourProgressNeedsALookFrom": "Your progress needs a look from your instructor, you'll be contacted via the email you provided when creating this account.",
    "reinforcementPrompt.aRecentLessonTouchedOnThis": "A recent lesson touched on this: “",
    "reinforcementPrompt.in": "In ",
    "reinforcementPrompt.pickingUpAThread": "Picking up a thread",
    "reinforcementPrompt.reinforcementReminder": "Reinforcement reminder",
    "reinforcementPrompt.thisCameUp": ", this came up: “",
    "reinforcementPrompt.worthCarryingIntoTodaySLesson": "”. Worth carrying into today’s lesson.",
    "resumeCard.areYouSureYourProgressWill": "Are you sure? Your progress will be lost.",
    "resumeCard.daysAgo_one": "{count}d ago",
    "resumeCard.daysAgo_other": "{count}d ago",
    "resumeCard.hoursAgo_one": "{count}h ago",
    "resumeCard.hoursAgo_other": "{count}h ago",
    "resumeCard.justNow": "just now",
    "resumeCard.minutesAgo_one": "{count}m ago",
    "resumeCard.minutesAgo_other": "{count}m ago",
    "resumeCard.phase": "Phase ",
    "resumeCard.resume": "Resume",
    "resumeCard.startFresh": "Start fresh",
    "resumeCard.wordsWritten": " words written",
    "resumeConfirmation.areYouSure": "Are you sure?",
    "resumeConfirmation.continueFromWhereILeftOff": "Continue from where I left off",
    "resumeConfirmation.awayForAboutMinutes_one": "You were away for about {count} minute.",
    "resumeConfirmation.awayForAboutMinutes_other": "You were away for about {count} minutes.",
    "resumeConfirmation.phaseLabel.listening": "Listening",
    "resumeConfirmation.phaseLabel.reading": "Reading",
    "resumeConfirmation.phaseLabel.speaking": "Speaking",
    "resumeConfirmation.phaseLabel.writing": "Writing",
    "resumeConfirmation.resumeLessonConfirmation": "Resume lesson confirmation",
    "resumeConfirmation.startOver": "Start over",
    "resumeConfirmation.thisWillRestartTheLessonFrom": "This will restart the lesson from the beginning. All progress will be lost.",
    "resumeConfirmation.welcomeBack": "Welcome back!",
    "resumeConfirmation.yesStartOver": "Yes, start over",
    "resumeConfirmation.youreOnThePhase": "You're on the {phase} phase of {lessonTitle}.",
    "resumeConfirmation.yourWritingDraftHasBeenSaved": "✓ Your writing draft has been saved.",
    "retakeOffer.finalListJoiner": ", and ",
    "retakeOffer.listSeparator": ", ",
    "retakeOffer.twoPhaseJoiner": " and ",
    "retakeOfferAnnouncement.decideLater": "Decide later",
    "retakeOfferAnnouncement.headingOne": "{phaseLabel} was below the target this time",
    "retakeOfferAnnouncement.headingOther": "{phaseLabel} were below the target this time",
    "retakeOfferAnnouncement.retakeNow": "Retake {phaseLabel} now",
    "retakeOfferAnnouncement.youCanRetakeItNowFor": "You can retake it now for a better score, or come back to it later — you'll be asked to choose before starting a different lesson.",
    "retakeOfferConfirmation.retakeOfferConfirmation": "Retake offer confirmation",
    "retakeOfferConfirmation.retakeThePreviousLesson": "Retake the previous lesson",
    "retakeOfferConfirmation.startTheNewLessonAnyway": "Start the new lesson anyway",
    "retakeOfferConfirmation.youHaveARetakeAvailable": "You have a retake available",
    "speakingRecapPanel.couldnTLoadYourSpeakingRecap": "Couldn't load your speaking recap.",
    "speakingRecapPanel.speakingRecap": "Speaking recap",
    "speakingRecapPanel.try": "Try: \"",
    "speakingRecapPanel.tryAgain": "Try again",
    "speakingRecapPanel.whatToWorkOn": "What to work on",
    "speakingRecapPanel.whatWentWell": "What went well",
    "speakingRecapPanel.wordsYouUsed": "Words you used",
    "streakDisplay.amazingStreakYouReOnFire": "Amazing streak! You're on fire!",
    "streakDisplay.dayMilestone": " day milestone!",
    "streakDisplay.dayStreak": "day streak",
    "streakDisplay.keepItUp": "Keep it up! ",
    "streakDisplay.lessonsDone": "lessons done",
    "streakDisplay.milestone": " milestone!",
    "streakDisplay.moreDaysToA": " more days to a ",
    "streakDisplay.startAStreak": "Start a streak!",
    "streakDisplay.thisWeek": "this week",
    "streakWidget.dayStreak": "day streak",
    "trialLimitModal.lessonsCompletedLessonscompleted10": " · Lessons completed: {lessonsCompleted}/10",
    "trialLimitModal.maybeLater": "Maybe later",
    "trialLimitModal.messages.dailyLimit.title": "That's your lesson for today!",
    "trialLimitModal.messages.dailyLimit.body": "Come back tomorrow to continue your streak, or upgrade to study at your own pace.",
    "trialLimitModal.messages.dailyLimit.cta": "Upgrade for unlimited access",
    "trialLimitModal.messages.lessonCap.title": "You've reached your free lesson limit",
    "trialLimitModal.messages.lessonCap.body": "You've completed all 10 free trial lessons. Upgrade to continue your CEFR journey.",
    "trialLimitModal.messages.lessonCap.cta": "See subscription plans",
    "trialLimitModal.messages.expired.title": "Your trial has ended",
    "trialLimitModal.messages.expired.body": "Subscribe to keep learning. All your progress and vocabulary are saved.",
    "trialLimitModal.messages.expired.cta": "Reactivate now",
    "trialLimitModal.trialDaysRemaining": "Trial days remaining: ",
    "vocabTooltip.couldNotLoadDefinitionTryAgain": "Could not load definition. Try again.",
    "vocabTooltip.grammar": "Grammar",
    "vocabTooltip.noDefinitionAvailable": "No definition available.",
    "vocabTooltip.seenTimeCount_one": "Seen {count} time",
    "vocabTooltip.seenTimeCount_other": "Seen {count} times",
    "vocabTooltip.vocabulary": "Vocabulary",
    "vocabularyPanel.keyVocabulary": "Key vocabulary (",
    "vocabularyProgress.encounterLabel.heard": "Heard",
    "vocabularyProgress.encounterLabel.read": "Read",
    "vocabularyProgress.encounterLabel.spoken": "Spoken",
    "vocabularyProgress.encounterLabel.written": "Written",
    "vocabularyProgress.mastered": "✓ Mastered",
    "vocabularyProgress.new": "NEW",
    "vocabularyProgress.noNewVocabularyInThisLesson": "No new vocabulary in this lesson",
    "vocabularyProgress.showAllWordsWords": "▶ Show all {words} words",
    "vocabularyProgress.showLess": "▼ Show less",
    "lessonHomePage.continueWithLesson": "Continue with lesson {position}",
    "lessonHomePage.startNextLesson": "Start lesson {position}",
    "lessonHomePage.progressLine": "{done} of {total} done in {level}",
    "lessonHomePage.listHeading": "Your {level} lessons",
    "lessonHomePage.filterNotDone": "Not done",
    "lessonHomePage.filterDone": "Done",
    "lessonHomePage.filterAll": "All",
    "lessonHomePage.searchPlaceholder": "Search lessons",
    "lessonHomePage.lessonRow": "Lesson {position}",
    "lessonHomePage.stateDone": "Done",
    "lessonHomePage.stateNext": "Next",
    "lessonHomePage.stateInProgress": "In progress",
    "lessonHomePage.stateRetakePending": "Retake offered",
    "lessonHomePage.stateLocked": "Locked",
    "lessonHomePage.lockedMessage": "Finish lesson {position} first.",
    "lessonHomePage.noMatches": "No lessons match.",
    "lessonHomePage.levelFinished": "You have finished every lesson in this level.",
    "blockProgressPopup.countOfTotal": "{done} of {total} lessons done",
    "blockOutcomeCopy.droppedSkills.heading": "{skills} moved down",
    "blockOutcomeCopy.droppedSkills.body": "{changes}. Your level is now {toBlock}. Starting from here needs a new block purchase.",
    "blockOutcomeCopy.demoted.heading": "{skills} moved down",
    "blockOutcomeCopy.demoted.body": "After two blocks below the bar: {changes}. Your other skills stay where they are. A new block purchase is needed to continue.",
    "retakeOfferConfirmation.lastLessonBelowTarget": "Some parts of your last lesson were below the target. You can retake those parts now — reading and listening bring new material, writing and speaking repeat the same task — or start this new lesson, but starting a new lesson means giving up that retake for good.",
    "lessonHomePage.loadFailedTitle": "We couldn't load your lessons",
    "lessonHomePage.loadFailedBody": "This is usually a short connection problem, and your progress is safe. Please try again.",
    "lessonHomePage.loadFailedRetry": "Try again",
    "lessonHomePage.noLessonsAtLevelTitle": "No {field} lessons at your level yet",
    "lessonHomePage.noLessonsAtLevelBody": "Your level is {level}, and we have no published {field} lessons at that level at the moment. Please contact support and we will help you find a way forward.",
    "lessonHomePage.unknownFieldTitle": "We can't find your specialty",
    "lessonHomePage.unknownFieldBody": "Your profile says \"{field}\", which matches none of our specialties. Please contact support and we will put it right.",
    "levelFeel.title": "How did that feel?",
    "levelFeel.question": "How did the {skill} part of your lessons feel so far?",
    "levelFeel.tooEasy": "Too easy",
    "levelFeel.aboutRight": "About right",
    "levelFeel.tooHard": "Too hard",
    "levelFeel.skip": "Skip",
    "levelFeel.thanks": "Thank you - this helps us check your level.",
    "preteachStrip.title": "Words to know first",
    "strugglingWriter.message": "Writing in English takes practice, and every attempt helps. If something in this task is unclear, our team is happy to help.",
    "strugglingWriter.contactSupport": "Contact support",
    "listeningAudioPlayer.playSlower": "Play slower (0.75×)",
    "listeningAudioPlayer.playAtNormalSpeed": "Play at normal speed",
    "vocabStep.title": "Match the words",
    "vocabStep.instructions": "Match each word to its meaning.",
    "vocabStep.setProgress": "Set {current} of {total}",
    "vocabStep.right": "Correct",
    "vocabStep.wrong": "Not quite",
    "vocabStep.correctMeaning": "Correct meaning:",
    "vocabStep.nextSet": "Next set",
    "vocabStep.continueToListening": "Continue to listening",
    "vocabStep.retryTitle": "Let's try once more",
    "vocabStep.retryBody": "You can look at the reading text first. Then match all the words again.",
    "vocabStep.viewReading": "View the reading text",
    "vocabStep.hideReading": "Hide the reading text",
    "vocabStep.startAgain": "Match the words again",
    "vocabStep.loadFailed": "We could not load the words. Please try again.",
    "vocabStep.reviewTitle": "Words from this lesson",
    "resumeCard.activityOf": "{phase} - activity {n} of {total}",
    "resumeCard.continueYourLesson": "Continue your lesson",
    "resumeCard.savedForLater": "You saved this lesson. Your place is kept.",
    "saveAndContinueLater.failed": "We could not save just now. Check your connection and try again.",
    "saveAndContinueLater.label": "Save and continue later",
    "saveAndContinueLater.note": "Your place is kept. You can continue from the lessons page.",
    "saveAndContinueLater.saving": "Saving..."
  },
  messages: {
    "messagesPage.backToSetup": "Back to setup",
    "messagesPage.title": "Messages",
    "messagesPage.empty": "No messages yet. Replies from our team and important notices about your account will appear here.",
    "messagesPage.markAllRead": "Mark all as read",
    "messagesPage.newBadge": "New",
    "messagesPage.fromSupport": "Support",
    "messagesPage.fromSystem": "Notice",
    "messagesPage.openConversation": "Open conversation",
    "messagesPage.back": "Back to messages",
    "messagesPage.yourReport": "Your report",
    "messagesPage.you": "You",
    "messagesPage.supportTeam": "Support team",
    "messagesPage.replyLabel": "Write a reply",
    "messagesPage.replyPlaceholder": "Type your reply to the support team…",
    "messagesPage.send": "Send reply",
    "messagesPage.sending": "Sending…",
    "messagesPage.sent": "Your reply was sent.",
    "messagesPage.loadFailed": "Your messages could not be loaded. Please try again.",
    "messagesPage.replyFailed": "Your reply could not be sent. Please try again.",
    "messagesPage.unreadCount": "{count} unread messages",
    "messagesPage.delete": "Delete",
    "messagesPage.deleteConversation": "Delete this conversation",
    "messagesPage.deleteConfirm": "Delete this message from your inbox? This cannot be undone.",
    "messagesPage.deleteConversationConfirm": "Delete this whole conversation from your messages? Our team keeps its own record of your report. This cannot be undone.",
    "messagesPage.deleteFailed": "It could not be deleted. Please try again.",
    "messagesPage.keepNote": "Messages stay here until you delete them.",
    "messagesPage.cancel": "Cancel"
  },
  onboarding: {
    "forgotPasswordPage.backToSignIn": "← Back to sign in",
    "forgotPasswordPage.emailAddress": "Email address",
    "forgotPasswordPage.enterYourEmailAddressAndWe": "Enter the e-mail address of your account. We will e-mail you what to do next.",
    "forgotPasswordPage.resetYourPassword": "Reset your password",
    "forgotPasswordPage.sendResetLink": "Send reset link",
    "forgotPasswordPage.youExampleCom": "you@example.com",
    "levelConfirmedPage.placementComplete": "Placement complete",
    "levelConfirmedPage.settingUpYourAccount": "Setting up your account…",
    "levelConfirmedPage.weLlTailorEveryLessonTo": "We'll tailor every lesson to this level.",
    "levelConfirmedPage.yourLevel": "Your level",
    "passwordResetConfirmationPage.backToSignIn": "Back to sign in",
    "passwordResetConfirmationPage.checkYourEmail": "Check your email",
    "passwordResetConfirmationPage.clickTheLinkInTheEmail": "Open the e-mail and follow it. A link to choose a new password works once and expires in one hour.",
    "passwordResetConfirmationPage.didnTReceiveTheEmail": "Didn't receive the email?",
    "passwordResetConfirmationPage.ifYouDonTSeeThe": "If you don't see the email, check your spam folder.",
    "passwordResetConfirmationPage.resendEmail": "Resend email",
    "passwordResetConfirmationPage.resendInCountdownS": "Resend in {countdown}s",
    "placementIntroPage.anAdaptivePlacementTestSoWe": "An adaptive placement test so we can match you with the right lessons.",
    "placementIntroPage.features.allFourSkills": "Covers all four skills — reading, listening, writing, and speaking",
    "placementIntroPage.features.adaptsToYourLevel": "Adapts to your level as you go — length varies by skill",
    "placementIntroPage.features.personalCefrProfile": "Builds a personal CEFR profile for each skill",
    "placementIntroPage.startLevelCheck": "Start Level Check",
    "placementIntroPage.step2Of3LevelCheck": "Step 2 of 3 — Level check",
    "placementIntroPage.yourPlacementTestIsnTFinished": "Your placement test isn't finished yet — every Irtaki lesson is matched to your level in all four skills, so we need the rest of the test before we can open one for you.",
    "profileSetupPage.couldnTLoadSpecialtiesPleaseRefresh": "Couldn't load specialties. Please refresh the page and try again.",
    "profileSetupPage.country": "Country",
    "profileSetupPage.preferredName": "Preferred name",
    "profileSetupPage.helpUsPersonaliseYourLearning": "Help us personalise your learning",
    "profileSetupPage.loadingSpecialties": " Loading specialties…",
    "profileSetupPage.pleaseFillInAllFields": "Please fill in all fields.",
    "profileSetupPage.selectYourCountry": "Select your country…",
    "profileSetupPage.step1Of3YourProfile": "Step 1 of 3 — Your profile",
    "profileSetupPage.subjectArea": "Subject area",
    "profileSetupPage.whatShouldWeCallYou": "What should we call you?",
    "signInPage.continueWithGoogle": "Continue with Google",
    "signInPage.donTHaveAnAccount": "Don't have an account?",
    "signInPage.emailAddress": "Email address",
    "signInPage.forgotPassword": "Forgot password?",
    "signInPage.or": "or",
    "signInPage.signIn": "Sign in",
    "signInPage.signInToContinueYourLearning": "Sign in to continue your learning",
    "signInPage.signUpFree": "Sign up free",
    "signInPage.welcomeBack": "Welcome back",
    "signUpPage.alreadyHaveAnAccount": "Already have an account?",
    "signUpPage.continueWithGoogle": "Continue with Google",
    "signUpPage.createYourAccount": "Create your account",
    "signUpPage.signIn": "Sign in",
    "signUpPage.startYourFree10DayTrial": "Start your free 10-day trial",
    "trialActivationPage.failedToActivateTrial": "Failed to activate trial. Please try again.",
    "trialActivationPage.10Days10Lessons": "10 days, 10 lessons",
    "trialActivationPage.benefits.0": "10 fully adaptive lessons",
    "trialActivationPage.benefits.1": "All 4 skills: Listening, Reading, Writing, Speaking",
    "trialActivationPage.benefits.2": "AI-powered feedback on every response",
    "trialActivationPage.benefits.3": "Personalised vocabulary tracking",
    "trialActivationPage.benefits.4": "CEFR level assessments after each lesson",
    "trialActivationPage.benefits.5": "Cancel anytime — no credit card needed",
    "trialActivationPage.completelyFree": " — completely free.",
    "trialActivationPage.startMyFreeTrial": "Start My Free Trial",
    "trialActivationPage.step3Of3StartYour": "Step 3 of 3 — Start your trial",
    "trialActivationPage.viewPaidPlans": "View paid plans →",
    "welcomePage.alreadyHaveAnAccount": "Already have an account? ",
    "welcomePage.byIrtaki": "by Irtaki",
    "welcomePage.continueWithGoogle": "Continue with Google",
    "welcomePage.emi": "EMI",
    "welcomePage.irtaki": "Irtaki",
    "welcomePage.masterEnglishForAcademicAndProfessional": "Master English for academic and professional success",
    "welcomePage.signIn": "Sign in",
    "levelConfirmedPage.cappedSkillNote": "Your {skill} was measured at {placed}, but your lessons start at {base}. You will begin {skill} at {served} and can move up from there.",
    "profileSetupPage.ageConfirm": "I am 18 or older",
    "profileSetupPage.ageConfirmRequired": "Please confirm that you are 18 or older to continue.",
    "ageGate.title": "One more thing",
    "ageGate.body": "Irtaki is for learners aged 18 or older. Please confirm your age to continue.",
    "ageGate.confirm": "I am 18 or older",
    "ageGate.signOut": "I am younger - sign out",
    "ageGate.failed": "Your answer could not be saved. Please try again.",
    "specialtyRequest.link": "My specialty isn't listed",
    "specialtyRequest.label": "Your specialty",
    "specialtyRequest.placeholder": "For example: Petroleum engineering",
    "specialtyRequest.help": "Write it in your own words. We'll email you when it's added.",
    "specialtyRequest.send": "Send request",
    "specialtyRequest.saveChanges": "Save changes",
    "specialtyRequest.received": "Thank you - we got your request.",
    "specialtyRequest.youAsked": "You asked for: {text}. We'll email you when it's added.",
    "specialtyRequest.interim": "We'll email you when it's added. You can start your course then.",
    "specialtyRequest.edit": "Edit",
    "specialtyRequest.withdraw": "Withdraw request",
    "specialtyRequest.withdrawn": "Your request was withdrawn.",
    "specialtyRequest.errorRequired": "Please type your specialty.",
    "specialtyRequest.errorTooLong": "Please keep it to {max} characters.",
    "specialtyRequest.errorRateLimited": "You have changed this several times. Please try again in an hour.",
    "specialtyRequest.errorGeneric": "We couldn't save your request. Please try again.",
    "placementHub.title": "Continue your placement test",
    "placementHub.intro": "Your answers so far are saved. Pick up right where you stopped - you can pause and come back whenever you like.",
    "placementHub.savedBanner": "Your progress is saved. You can continue any time from question {n} of {skill}.",
    "placementHub.savedNote": "The answer you were working on was not kept.",
    "placementHub.stateDone": "Done",
    "placementHub.stateInProgress": "In progress - question {n}",
    "placementHub.stateNotStarted": "Not started",
    "placementHub.questionsLeft": "Questions left (about): {n}",
    "placementHub.totalLeft": "About {n} questions left in all. The test adapts to you, so the exact number varies.",
    "placementHub.continueSkill": "Continue: {skill}",
    "placementHub.startSkill": "Start: {skill}",
    "placementHub.youCanPause": "You can pause at any question and come back later - your answers are saved.",
    "profileSetupPage.specialtyFixed": "Fixed for your account",
    "profileSetupPage.changeSpecialty": "Change",
    "profileSetupPage.saveFailed": "Failed to save profile. Please try again.",
    "welcomePage.getStarted": "Get started: choose your specialty",
    "signUpPage.yourSpecialty": "Your specialty:",
    "chooseSpecialty.title": "Choose your specialty",
    "chooseSpecialty.intro": "Read what each course covers and who it is for, then choose. Your specialty cannot be changed later.",
    "chooseSpecialty.loadFailed": "We couldn't load the specialties. Please try again.",
    "chooseSpecialty.none": "No specialty is open yet. Please come back soon.",
    "chooseSpecialty.noTagline": "Read the description to see who this course is for.",
    "chooseSpecialty.choose": "Choose this specialty",
    "chooseSpecialty.readMore": "Read more",
    "chooseSpecialty.notListedTitle": "My specialty isn't listed",
    "chooseSpecialty.notListedHelp": "Tell us which one you need. We'll email you when it's added.",
    "specialtyPage.back": "All specialties",
    "specialtyPage.loadFailed": "We couldn't load this page. Please try again.",
    "specialtyPage.noDescription": "The description of this specialty is not available yet.",
    "specialtyPage.englishOnly": "This description is not available in Arabic yet, so it is shown in English.",
    "specialtyPage.choose": "Choose {name}",
    "visitorRequest.name": "Your name",
    "visitorRequest.email": "Your email",
    "visitorRequest.help": "Write it in your own words. We'll send you a link to confirm.",
    "visitorRequest.consent": "You may email me when this specialty is added. My details are used only for this request.",
    "visitorRequest.errorName": "Please type your name.",
    "visitorRequest.errorNameTooLong": "Please keep your name to {max} characters.",
    "visitorRequest.errorEmail": "Please type a valid email address.",
    "visitorRequest.errorConsent": "Please tick the box so we may email you.",
    "visitorRequest.errorRateLimited": "Too many requests from this connection. Please try again in an hour.",
    "visitorRequest.checkInbox": "Check your inbox",
    "visitorRequest.sentTo": "If {email} is correct, we sent a link to confirm your request. The link works for 7 days.",
    "visitorRequest.confirmedTitle": "Thank you - your request is confirmed",
    "visitorRequest.confirmedBody": "You asked for: {specialty}. We'll email you when it's added.",
    "visitorRequest.confirmInvalid": "This link is not valid. It may have been used already.",
    "visitorRequest.confirmExpired": "This link has expired (it works for 7 days). Please send your request again.",
    "visitorRequest.backToSpecialties": "See the specialties",
    "forgotPasswordPage.errorInvalidEmail": "Please enter a valid email address.",
    "forgotPasswordPage.errorRateLimited": "Too many requests. Please try again in an hour.",
    "forgotPasswordPage.errorGeneric": "We could not send your request. Please check your connection and try again.",
    "forgotPasswordPage.googleHint": "Signed up with Google? You have no password to reset: go back and use Continue with Google.",
    "passwordResetConfirmationPage.ifAnAccountExists": "If an account exists for this address, we have sent an e-mail.",
    "signInPage.googleHint": "Signed up with Google? Use Continue with Google.",
    "authActionPage.checking": "Checking your link...",
    "authActionPage.title": "Choose a new password",
    "authActionPage.forAccount": "For the account",
    "authActionPage.newPassword": "New password",
    "authActionPage.repeatPassword": "Repeat the new password",
    "authActionPage.save": "Save the new password",
    "authActionPage.tooShort": "Use at least {min} characters.",
    "authActionPage.mismatch": "The two passwords are not the same.",
    "authActionPage.weak": "This password is too weak. Please choose a longer one.",
    "authActionPage.doneTitle": "Your password has been changed",
    "authActionPage.doneBody": "You can now sign in with your new password.",
    "authActionPage.signIn": "Sign in",
    "authActionPage.expiredTitle": "This link has expired or has already been used",
    "authActionPage.expiredBody": "A link to choose a new password works once and expires in one hour. Ask for a new one.",
    "authActionPage.sendNewLink": "Send a new link",
    "authActionPage.closed": "This account has been closed. Contact contact@irtaki.net.",
    "authActionPage.failed": "Something went wrong. Please check your connection and try again.",
    "authActionPage.tryAgain": "Try again",
    "visitorRequest.confirmPrompt": "Press the button to confirm your specialty request.",
    "visitorRequest.confirmButton": "Confirm my request",
    "signUpPage.withEmail": "Sign up with email",
    "signUpPage.password": "Password",
    "signUpPage.showPassword": "Show",
    "signUpPage.hidePassword": "Hide",
    "signUpPage.showPasswordLabel": "Show the password",
    "signUpPage.hidePasswordLabel": "Hide the password",
    "signUpPage.passwordHint": "At least 8 characters. A short sentence you will remember works well.",
    "signUpPage.createMyAccount": "Create my account",
    "signUpPage.noGmailNeeded": "No Google account? Use any email address you check, for example on an iPhone.",
    "signInPage.password": "Password",
    "verifyEmailPage.title": "Confirm your email",
    "verifyEmailPage.sentTo": "We sent a link to",
    "verifyEmailPage.body": "Open the link in that email to confirm your address, then come back here. Your placement test starts after that.",
    "verifyEmailPage.spamHint": "Not there? Look in your spam or junk folder.",
    "verifyEmailPage.resend": "Resend the email",
    "verifyEmailPage.resent": "Sent. It can take a minute to arrive.",
    "verifyEmailPage.resendWait": "You have asked for several emails. You can ask again in {minutes} min.",
    "verifyEmailPage.sendFailed": "We could not send the email just now. Please try again in a moment.",
    "verifyEmailPage.change": "Change the email address",
    "verifyEmailPage.newAddress": "New email address",
    "verifyEmailPage.sendToNewAddress": "Send the link to this address",
    "verifyEmailPage.cancel": "Cancel",
    "verifyEmailPage.changed": "Address changed. We sent a new link.",
    "verifyEmailPage.confirmed": "I've confirmed it",
    "verifyEmailPage.notYet": "We can't see the confirmation yet. Open the link in the email, then tap “I've confirmed it” again.",
    "verifyEmailPage.signOut": "Sign out",
    "authActionPage.verifyTitle": "Confirm your email address",
    "authActionPage.verifyBody": "Tap the button to confirm this address for your EMI account.",
    "authActionPage.verifyButton": "Confirm my email",
    "authActionPage.verifiedTitle": "Your email address is confirmed",
    "authActionPage.verifiedBody": "You can now continue to your placement test.",
    "authActionPage.continue": "Continue",
    "authActionPage.verifyExpiredBody": "If you have already confirmed your address, just continue. Otherwise ask for a new email from the app.",
    "placementHub.redoBanner": "Our team asked you to take these parts of the level check again: {skills}. Your other results stay as they are. Your lessons continue once you have finished.",
    "placementHub.stateRedo": "To take again"
  },
  placement: {
    "placementFlowPage.skillAbbr.reading": "REA",
    "placementFlowPage.skillAbbr.listening": "LIS",
    "placementFlowPage.skillAbbr.writing": "WRI",
    "placementFlowPage.skillAbbr.speaking": "SPE",
    "apiError.generic": "Something went wrong with your placement test. Please try again.",
    "apiError.notAuthorized": "You're not authorized to view this placement attempt.",
    "apiError.placementAlreadyLocked": "This skill's placement is already locked — no retakes.",
    "apiError.placementAttemptNotCompleted": "This placement attempt isn't finished yet.",
    "apiError.placementAttemptNotFound": "We couldn't find that placement attempt.",
    "apiError.placementAttemptNotInProgress": "This placement attempt is no longer in progress.",
    "apiError.placementItemNotFound": "We couldn't find that placement question.",
    "apiError.placementNoEstimates": "Complete the placement test first to see your level.",
    "apiError.placementUnavailable": "Placement is briefly unavailable — please come back in a few minutes.",
    "audioMCQRenderer.answerOptions": "Answer options",
    "mCQRenderer.answerOptions": "Answer options",
    "placementFlowPage.comingInAFutureUpdate": "Coming in a future update.",
    "placementFlowPage.nextSkill": "Next: {skill}",
    "placementFlowPage.questionTypeNotYetAvailable": "Question type {type} is not yet available.",
    "placementFlowPage.skillComplete": "{skill} complete",
    "placementFlowPage.skillLabel.listening": "Listening",
    "placementFlowPage.skillLabel.reading": "Reading",
    "placementFlowPage.skillLabel.speaking": "Speaking",
    "placementFlowPage.skillLabel.writing": "Writing",
    "placementFlowPage.skillLabelLower.listening": "listening",
    "placementFlowPage.skillLabelLower.reading": "reading",
    "placementFlowPage.skillLabelLower.speaking": "speaking",
    "placementFlowPage.skillLabelLower.writing": "writing",
    "placementFlowPage.skillQuestionN": "{skill} · Question {n}",
    "placementFlowPage.somethingWentWrong": "Something went wrong",
    "placementFlowPage.tryAgain": "Try again",
    "placementFlowPage.yourSkillLevel": "Your {skill} level",
    "shortTextRenderer.evaluating": "Evaluating…",
    "shortTextRenderer.skipThisQuestion": "Skip this question",
    "shortTextRenderer.wordCount_one": "{count} word",
    "shortTextRenderer.wordCount_other": "{count} words",
    "shortTextRenderer.writeYourAnswerHere": "Write your answer here…",
    "shortTextRenderer.yourWrittenAnswer": "Your written answer",
    "spokenPromptRenderer.checkThatYourMicrophoneIsnT": "Check that your microphone isn't muted or disabled in your system settings",
    "spokenPromptRenderer.evaluating": "Evaluating…",
    "spokenPromptRenderer.iVeAllowedItTryAgain": "I've allowed it — try again",
    "spokenPromptRenderer.irtakiIsASpokenEnglishCourse": "Irtaki is a spoken-English course. This test measures how you speak, not how you type — so we need to hear you before we can find your level.",
    "spokenPromptRenderer.plugInAnExternalMicrophoneOr": "Plug in an external microphone or headset",
    "spokenPromptRenderer.reRecord": "Re-record",
    "spokenPromptRenderer.recordingMathS": "Recording… {math}s",
    "spokenPromptRenderer.skipThisQuestion": "Skip this question",
    "spokenPromptRenderer.somethingWentWrongYourRecordingWas": "Something went wrong. Your recording was not lost.",
    "spokenPromptRenderer.speakingPracticeNeedsYourMicrophone": "Speaking practice needs your microphone",
    "spokenPromptRenderer.stillBlockedFollowTheStepsAbove": "Still blocked. Follow the steps above, or try a different browser or device with a working microphone.",
    "spokenPromptRenderer.submitThisRecording": "Submit this recording",
    "spokenPromptRenderer.switchToAPhoneTabletOr": "Switch to a phone, tablet, or laptop with a built-in microphone",
    "spokenPromptRenderer.tapToRecord": "Tap to record",
    "spokenPromptRenderer.tapToStop": "Tap to stop",
    "spokenPromptRenderer.thatWasTooQuickHoldAnd": "That was too quick — hold and speak for at least a second.",
    "spokenPromptRenderer.tryAgain": "Try again",
    "spokenPromptRenderer.tryOneOfThese": "Try one of these:",
    "spokenPromptRenderer.upToTimelimitsecondsS": "Up to {timeLimitSeconds}s",
    "spokenPromptRenderer.weCouldnTDetectAMicrophone": "We couldn't detect a microphone on this device.",
    "spokenPromptRenderer.yourBrowserIsCurrentlyBlockingMicrophone": "Your browser is currently blocking microphone access. This isn't a mistake on your end — most browsers block it by default until a site asks.",
    "placementFlowPage.saveAndContinueLater": "Save and continue later",
    "placementFlowPage.saveNote": "Your earlier answers are saved. The answer on this screen is not.",
    "placementFlowPage.continueLater": "Continue later",
    "placementFlowPage.writingConsent.label": "You may use my written answers, without my name, to help improve the placement test.",
    "placementFlowPage.writingConsent.note": "Optional - you can leave it unticked.",
    "placementFlowPage.writingConsent.saved": "Saved.",
    "placementFlowPage.writingConsent.error": "We couldn't save your choice. Please try again.",
    "gradingWait.checking": "Checking your answer…",
    "gradingWait.note": "This usually takes a few seconds.",
    "checklist.heading": "In your answer, say:",
    "checklist.S-A1-1": "your name\nyour job, or what you study\none thing you like",
    "checklist.S-A1-2": "two things in the room\nuse \"there is\" or \"there are\"",
    "checklist.S-A1-3": "the time you wake up\nwhat you eat for breakfast",
    "checklist.S-A1-4": "how many people are in your family (a number)\none thing about one person",
    "checklist.S-A1-5": "your favourite food\nwhy you like it (a reason)",
    "checklist.S-A1-6": "one thing you can do well\none thing you cannot do",
    "checklist.S-A1-7": "how you travel (car, bus, on foot ...)\nhow long it takes (minutes or hours)",
    "checklist.S-A1-8": "your friend's name\nwhere your friend lives\none thing you do together",
    "checklist.S-A1-9": "the weather in summer\nthe weather in winter",
    "checklist.S-A1-10": "one thing you do at the weekend",
    "checklist.S-A2-1": "at least two things you did yesterday\nwords like first, then, after that, finally",
    "checklist.S-A2-2": "one thing you like about your hometown\none thing you don't like",
    "checklist.S-A2-3": "two different pieces of advice",
    "checklist.S-A2-4": "where you went\nwhat you did there",
    "checklist.S-A2-5": "your hobby\nhow you started it",
    "checklist.S-A2-6": "what you plan to do next year\nwhy",
    "checklist.S-A2-7": "who the person is\nwhat they are like",
    "checklist.S-A2-8": "the two places\nwhich one you preferred\nwhy",
    "checklist.S-A2-9": "what went wrong\nwhat you did",
    "checklist.S-A2-10": "at least one thing you do to prepare",
    "checklist.S-B1-1": "the meal or restaurant experience\nwhy you remember it",
    "checklist.S-B1-2": "living with roommates\nliving alone\nwhich you prefer, and why",
    "checklist.S-B1-3": "the neighbourhood you recommend\nat least one reason",
    "checklist.S-B1-4": "the challenge\nwhat you did about it",
    "checklist.S-B1-5": "the skill\nwhy it interests you",
    "checklist.S-B1-6": "which type you are (you plan everything, or you decide as you go)\nat least one reason",
    "checklist.S-B1-7": "the skill\nat least two steps, in order",
    "checklist.S-B1-8": "the change in your daily life\nhow you feel about it",
    "checklist.S-B1-9": "one change you would make\nat least one reason",
    "checklist.S-B1-10": "the advice you were given\nthat you did not follow it\nwhat happened",
    "checklist.S-B2-1": "your position\none counter-argument, and your answer to it",
    "checklist.S-B2-2": "the problem\nits likely cause\na possible solution",
    "checklist.S-B2-3": "your verdict: convincing or not\nreasons about the claim itself (evidence, other explanations)",
    "checklist.S-B2-4": "your view, and why you hold it\none downside of social media",
    "checklist.S-B2-5": "the decision you disagreed with\nwhat you would have done instead",
    "checklist.S-B2-6": "the choice you argue for\nthe strongest objection to it, and your answer to it",
    "checklist.S-B2-7": "at least one intended effect\nat least one unintended effect",
    "checklist.S-B2-8": "accountability\ntrust\nhow the two pull against each other",
    "checklist.S-B2-9": "two ways to reduce air pollution\nwhich one you would do first, and why",
    "checklist.S-B2-10": "a way to test the claim (what to measure, whom to compare)\nnot only whether you agree",
    "checklist.S-C1-1": "your position\none serious objection to it, and your answer",
    "checklist.S-C1-2": "at least two stakeholders\nhow their interests differ",
    "checklist.S-C1-3": "at least one hidden assumption in the claim\nwhether it holds",
    "checklist.S-C1-4": "your position\nthe limits or weaknesses of your own position",
    "checklist.S-C1-5": "the strengths\nthe risks\nyour overall evaluation",
    "checklist.S-C1-6": "the policy you choose\nwhere its intentions and its real effects differ",
    "checklist.S-C1-7": "the strongest case against your own view\nwhat that case still fails to explain",
    "checklist.S-C1-8": "when expertise may transfer to another field\nwhen it clearly does not",
    "checklist.S-C1-9": "how you would judge the two sources (methods, funding, sample, other studies)\nnot just which side you pick",
    "checklist.S-C1-10": "your assessment: a useful observation, or a way of dismissing concerns\nthe reasons behind it",
    "checklist.W-A2-6": "at least two things you did",
    "checklist.W-B1-6": "at least three steps, in order",
    "checklist.W-B2-1": "the big city\nthe small town\nwhich is better for quality of life\nexplain at least one point with a reason or an example",
    "checklist.W-B2-3": "one advantage\none disadvantage\nexplain at least one of them with a reason"
  },
  profile: {
    "languagePicker.language": "Language",
    "blockProgressCopy.skillLabel.reading": "Reading",
    "blockProgressCopy.skillLabel.listening": "Listening",
    "blockProgressCopy.skillLabel.writing": "Writing",
    "blockProgressCopy.skillLabel.speaking": "Speaking",
    "blockProgressCopy.countWord.two": "Two",
    "blockProgressCopy.countWord.three": "Three",
    "blockProgressCopy.countWord.four": "Four",
    "blockProgressCopy.joinWithAnd.twoPartJoiner": " and ",
    "blockProgressCopy.joinWithAnd.listSeparator": ", ",
    "blockProgressCopy.joinWithAnd.finalListJoiner": ", and ",
    "blockProgressCopy.isFurthestBehindStartThere": " is furthest behind — start there.",
    "blockProgressCopy.neededToAdvance": "% needed to advance: ",
    "blockProgressCopy.needsToAverage": " needs to average ",
    "blockProgressCopy.skillsAreBelowThe": " skills are below the ",
    "blockProgressCopy.theRestOfYourScoresAre": " The rest of your scores are already enough.",
    "blockProgressCopy.toCountTowardAdvancementItS": "% to count toward advancement. It's currently at ",
    "blockProgressCopy.share.behind": "{count} of {size} lessons in this stage scored {bar}% or more. {required}% are needed to advance.",
    "blockProgressCopy.share.named": "{count} of {size} lessons in this stage scored {bar}% or more — {required}% are needed to advance. {skill} is the main factor: its average is {mean}%. Bringing that up is the fastest way to close the gap.",
    "blockProgressCopy.share.onTrack": "On track to advance: {count} of {size} lessons in this stage scored {bar}% or more ({required}% needed).",
    "lessonHistory.duration": "Duration: ",
    "lessonHistory.loadMore": "Load More",
    "lessonHistory.min": " min",
    "lessonHistory.noCompletedLessonsYetStartYour": "No completed lessons yet. Start your first lesson!",
    "lessonHistory.phaseScores": "Phase Scores",
    "profilePage.activeSubscription": "Active Subscription",
    "profilePage.dayStreak": "Day streak",
    "profilePage.deleteAccount": "Delete Account",
    "profilePage.deleteMyAccount": "Delete My Account",
    "profilePage.email": "Email",
    "profilePage.freeTrial": "Free Trial",
    "profilePage.lessonHistory": "Lesson History",
    "profilePage.lessonsDone": "Lessons done",
    "profilePage.lessonsRemaining": " lessons remaining",
    "profilePage.managePlan": "Manage Plan",
    "profilePage.myProfile": "My Profile",
    "profilePage.noActivePlan": "No active plan",
    "profilePage.preferredName": "Preferred name",
    "profilePage.signOut": "Sign out",
    "profilePage.skillLabel.listening": "Listening",
    "profilePage.skillLabel.reading": "Reading",
    "profilePage.skillLabel.speaking": "Speaking",
    "profilePage.skillLabel.writing": "Writing",
    "profilePage.thisWeek": "This week",
    "profilePage.vocabulary": "Vocabulary",
    "profilePage.yourProgress": "Your Progress",
    "progressChart.completeMoreLessonsToSeeYour": "Complete more lessons to see your progress chart",
    "progressChart.completedLessonsOverallScoreRange": " completed lessons · Overall score range: ",
    "progressChart.overall": "Overall",
    "progressChart.scoreTrend": "Score Trend",
    "progressChart.skillLabel.listening": "Listening",
    "progressChart.skillLabel.reading": "Reading",
    "progressChart.skillLabel.speaking": "Speaking",
    "progressChart.skillLabel.writing": "Writing",
    "vocabularyStats.count": "{count}",
    "vocabularyStats.encounterCoverage": "Encounter Coverage",
    "vocabularyStats.levelCount": "{level}: {count}",
    "vocabularyStats.recentWords": "Recent Words",
    "vocabularyStats.wordsByLevel": "Words by Level",
    "vocabularyStats.yourVocabularyLogWillGrowAs": "Your vocabulary log will grow as you complete lessons.",
    "vocabularyStats.total": "{count} Total",
    "vocabularyStats.mastered": "{count} Mastered ✓",
    "vocabularyStats.inProgress": "{count} In Progress",
    "vocabularyStats.encounter.read": "Read",
    "vocabularyStats.encounter.heard": "Heard",
    "vocabularyStats.encounter.written": "Written",
    "vocabularyStats.encounter.spoken": "Spoken",
    "blockProgress.countOfTotal": "{done} of {total} lessons done",
    "emailPrefs.title": "Email",
    "emailPrefs.studyReminders": "Study reminders by email",
    "emailPrefs.studyRemindersHint": "A friendly reminder if you have not studied for a few days. Important emails about your account and payments are always sent.",
    "emailPrefs.saveFailed": "Your choice could not be saved. Please try again.",
    "profilePage.specialty": "Specialty",
    "profilePage.specialtyFixed": "Your specialty was chosen at sign-up and cannot be changed.",
    "profilePage.deleteAccountExplained": "Delete your account. You are signed out at once; your data is deleted for good after 6 months, unless you sign in before then and choose Keep my account. A record of each payment is kept for 10 years."
  },
  speaking: {
    "composer.finish": "Finish",
    "composer.speak": "Speak",
    "composer.type": "Type",
    "conversationThread.alex": "Alex",
    "conversationThread.heardAs": "What we heard:",
    "conversationThread.nothingHeard": "We could not hear any words in this answer.",
    "conversationThread.replay": " Replay",
    "conversationThread.you": "You",
    "feedbackPanel.feedback": "Feedback",
    "feedbackPanel.alexHasToldYouTheSituation": "Alex has told you the situation. Say what you would do.",
    "feedbackPanel.scaffolding": "Scaffolding",
    "feedbackPanel.useThis": "Use this",
    "micButton.pause": "Pause",
    "micButton.paused": "Paused",
    "micButton.restart": "Restart",
    "micButton.resume": "Resume",
    "micButton.startRecording": "Start recording",
    "micButton.stopRecording": "Stop recording",
    "micManager.chrome": "Chrome:",
    "micManager.clickTheCameraIconClearBlocked": " Click the camera icon → Clear blocked status.",
    "micManager.clickTheLockIconInThe": " Click the lock icon in the address bar → Allow microphone.",
    "micManager.connectAMicrophoneOrUseThe": "Connect a microphone or use the text input instead.",
    "micManager.firefox": "Firefox:",
    "micManager.microphoneAccessDenied": "Microphone access denied",
    "micManager.noMicrophoneFound": "No microphone found",
    "micManager.safari": "Safari:",
    "micManager.safariSettingsForThisWebsiteMicrophone": " Safari → Settings for this Website → Microphone → Allow.",
    "micManager.tryAgain": "Try again",
    "moodRail.bandLabel.delighted": "Delighted",
    "moodRail.bandLabel.frustrated": "Frustrated",
    "moodRail.bandLabel.losingYou": "Losing you",
    "moodRail.bandLabel.neutral": "Neutral",
    "moodRail.bandLabel.warm": "Warm",
    "moodRail.alex": "Alex",
    "situationPanel.alexRole": "Alex's role",
    "situationPanel.youAre": "You are",
    "speakingMicWarning.checkMyMicrophone": "Check my microphone",
    "speakingMicWarning.checking": "Checking…",
    "speakingMicWarning.continueAnyway": "Continue anyway",
    "speakingMicWarning.headsUpBeforeYouStartTalking": "Heads up before you start talking with Alex",
    "speakingMicWarning.microphoneAccessConfirmed": "Microphone access confirmed.",
    "speakingMicWarning.microphoneAccessIsBlockedCheckYour": "Microphone access is blocked. Check your browser's address bar or site settings to allow it.",
    "speakingMicWarning.microphoneCheckBeforeSpeaking": "Microphone check before speaking",
    "speakingMicWarning.noMicrophoneWasFoundOnThis": "No microphone was found on this device.",
    "speakingMicWarning.thisPhaseNeedsYourMicrophoneIf": "This phase needs your microphone. If it's off, blocked, or missing — or if you type your answers instead of speaking them — this phase will score 0%, because speaking is graded on speech, not text.",
    "speakingMicWarning.youCanFixYourMicrophoneNow": "You can fix your microphone now, or continue anyway and retake this phase later for a real score.",
    "composer.typeFirstAnswer": "Type your first answer; speaking opens after it."
  },
  subscription: {
    "checkoutError.checkoutFailed": "We couldn't start your checkout. Please try again, or contact support if this continues.",
    "checkoutError.checkoutSessionNoUrl": "We couldn't start your checkout. Please try again, or contact support if this continues.",
    "checkoutError.invalidPlanType": "That plan isn't available. Please choose a plan and try again.",
    "checkoutError.notAuthenticated": "Please sign in again to continue.",
    "checkoutError.planPriceNotConfigured": "That plan isn't available in your currency right now. Please try another plan, or contact support.",
    "checkoutError.progressReviewRequired": "Your progress needs a look from your instructor. You'll be contacted via the email you provided when creating this account.",
    "checkoutError.slickpayMissingFields": "Please provide your phone number to continue.",
    "checkoutError.slickpayInvalidPhone": "That phone number doesn't look right. Please enter a valid mobile number, for example 0555 12 34 56.",
    "checkoutError.slickpayTransactionFailed": "Your payment couldn't be processed. Please try again, or contact support if this continues.",
    "checkoutError.slickpayConfirmFailed": "We couldn't confirm your payment yet. This can take a few minutes — check back shortly, or contact support if this continues.",
    "featureBullets.all4Skills": "All 4 skills",
    "featureBullets.aiEvaluationAndFeedback": "AI feedback",
    "featureBullets.lessonsPerMonth30": "30 lessons per month",
    "featureBullets.unusedLessonsCarryOver": "Finish unused lessons the following month",
    "featureBullets.completesLevelTo120Lessons": "Completes your current level to 120 lessons total",
    "featureBullets.validFor365Days": "Valid for 365 days",
    "paymentSuccessPage.activatingYourSubscription": "Activating your subscription…",
    "paymentSuccessPage.goToLessonsNow": "Go to lessons now",
    "paymentSuccessPage.paymentReceived": "Payment received!",
    "subscribePage.chooseThePlanThatWorksFor": "Choose the plan that works for you",
    "subscribePage.getMonthly": "Get Monthly",
    "subscribePage.getBlock": "Get Block",
    "subscribePage.loadingPrices": "Loading prices…",
    "subscribePage.planDefs.block.name": "Block",
    "subscribePage.planDefs.block.period": "one-time",
    "subscribePage.planDefs.monthly.name": "Monthly",
    "subscribePage.planDefs.monthly.period": "/month",
    "subscribePage.pricesUnavailable": "We couldn't load pricing right now. Please try again in a moment.",
    "subscribePage.redirectingToPayment": "Redirecting to payment…",
    "subscribePage.securePaymentViaSlickpay": "Secure one-time payment via SlickPay. No auto-renewal.",
    "subscribePage.securePaymentViaStripeCancelAnytime": "Secure payment via Stripe. Cancel future renewals anytime — payments already made are not refunded.",
    "subscribePage.slickpayForm.continueButton": "Continue to Payment",
    "subscribePage.slickpayForm.phoneLabel": "Phone number",
    "subscribePage.slickpayForm.phonePlaceholder": "e.g. 0555 12 34 56",
    "subscribePage.slickpayForm.title": "One more thing before you pay",
    "subscribePage.unlockYourFullPotential": "Unlock your full potential",
    "subscriptionCancelledScreen.cefrLevelsAndSkillScoresPreserved": "✓ CEFR levels and skill scores preserved",
    "subscriptionCancelledScreen.endedOn": "Ended on",
    "subscriptionCancelledScreen.lessonCompletionRecordsIntact": "✓ Lesson completion records intact",
    "subscriptionCancelledScreen.lessonsCompleted": "Lessons completed",
    "subscriptionCancelledScreen.plan": "Plan",
    "subscriptionCancelledScreen.planEndedOnDate": "Your {plan} plan ended on {date}",
    "subscriptionCancelledScreen.planName.block": "Block",
    "subscriptionCancelledScreen.planName.monthly": "Monthly",
    "subscriptionCancelledScreen.reactivateAnytimeToPickUpWhere": "Reactivate anytime to pick up where you left off",
    "subscriptionCancelledScreen.reactivateMySubscription": "Reactivate My Subscription",
    "subscriptionCancelledScreen.subscriptionEnded": "Subscription Ended",
    "subscriptionCancelledScreen.vocabularyLogAndLearningHistorySaved": "✓ Vocabulary log and learning history saved",
    "subscriptionCancelledScreen.yourProgressIsSafe": "Your progress is safe ",
    "trialDailyLimitScreen.lessonsUsed": "Lessons Used",
    "trialDailyLimitScreen.todaySLessonIsDone": "Today's lesson is done! ",
    "trialDailyLimitScreen.trialDays": "Trial Days",
    "trialDailyLimitScreen.upgradeNow": "Upgrade Now",
    "trialDailyLimitScreen.wantUnlimitedLessons": "Want unlimited lessons?",
    "trialDailyLimitScreen.yourNextLessonIsAvailableTomorrow": "Your next lesson is available tomorrow (",
    "trialExhaustedScreen.chooseAPlan": "Choose a Plan",
    "trialExhaustedScreen.dayStreak": "Day Streak",
    "trialExhaustedScreen.inStrongStrongestskillStrong": " in <strong>{strongestSkill}</strong>",
    "trialExhaustedScreen.keepGoingSubscribeToUnlockAll": "Keep going — subscribe to unlock all lessons at every level.",
    "trialExhaustedScreen.lessons": "Lessons",
    "trialExhaustedScreen.maybeLater": "Maybe Later",
    "trialExhaustedScreen.trialComplete": "Trial Complete!",
    "trialExhaustedScreen.wordsLearned": "Words Learned",
    "trialExhaustedScreen.youReMakingGreatProgress": "You're making great progress",
    "trialExhaustedScreen.youVeCompletedYourFreeTrial": "You've completed your free trial",
    "trialExhaustedScreen.yourLevel": "Your Level",
    "trialExpiredScreen.chooseAPlan": "Choose a Plan",
    "trialExpiredScreen.currentLevel": "Current level",
    "trialExpiredScreen.days": " days",
    "trialExpiredScreen.lessonsCompleted": "Lessons completed",
    "trialExpiredScreen.subscribeToContinueLearningAndUnlock": "Subscribe to continue learning and unlock lessons at every CEFR level.",
    "trialExpiredScreen.trialDuration": "Trial duration",
    "trialExpiredScreen.trialEnded": "Trial Ended",
    "trialExpiredScreen.wordsLearned": "Words learned",
    "trialExpiredScreen.youReMakingProgressOnYour": "You're making progress on your English learning journey.",
    "trialExpiredScreen.your10DayFreeTrialPeriod": "Your 10-day free trial period has ended",
    "checkoutError.cardPaymentDisabled": "Card payment is not available yet.",
    "checkoutError.gatewayUnavailable": "Payment temporarily unavailable — our team has been notified and may contact you.",
    "paymentSuccessPage.checking.title": "Checking your payment…",
    "paymentSuccessPage.checking.body": "We are asking SlickPay about your payment. This usually takes a few seconds.",
    "paymentSuccessPage.pending.title": "We haven't received your payment yet",
    "paymentSuccessPage.pending.body": "If you have just paid, it can take a few minutes to arrive. You can check again, or close this page: we keep checking in the background and will activate your subscription as soon as the payment is confirmed.",
    "paymentSuccessPage.failed.title": "The payment did not go through",
    "paymentSuccessPage.failed.body": "SlickPay reported that this payment failed. You can choose a plan and try again.",
    "paymentSuccessPage.cancelled.title": "The payment was cancelled",
    "paymentSuccessPage.cancelled.body": "This payment was cancelled at SlickPay and nothing was activated. You can try again whenever you are ready.",
    "paymentSuccessPage.expired.title": "This payment has expired",
    "paymentSuccessPage.expired.body": "This invoice was not paid in time. You can choose a plan and start again.",
    "paymentSuccessPage.needsSupport.title": "We need to look at your payment",
    "paymentSuccessPage.needsSupport.body": "We received your payment but could not activate your subscription automatically. Please contact support and quote the reference below. We will sort it out with you.",
    "paymentSuccessPage.notFound.title": "We could not find a payment to check",
    "paymentSuccessPage.notFound.body": "If you have paid, please contact support. If you have not paid yet, you can choose a plan and start again.",
    "paymentSuccessPage.checkFailed": "We couldn't reach the payment provider just now. Please try again in a moment.",
    "paymentSuccessPage.checkAgain": "Check payment status again",
    "paymentSuccessPage.chooseAPlan": "Choose a plan",
    "paymentSuccessPage.reference": "Reference: {ref}",
    "subscribePage.cardPaymentComingSoon.title": "Card payment coming soon",
    "subscribePage.cardPaymentComingSoon.body": "We are about to open card payments for learners outside Algeria. Thank you for your patience: you will be able to subscribe here as soon as it is ready.",
    "subscribePage.testOffer.badge": "TEST",
    "subscribePage.testOffer.title": "TEST: 1 day of access",
    "subscribePage.testOffer.body": "Admin-only test purchase of {amount} DZD, paid through the same SlickPay path as the real plans.",
    "subscribePage.testOffer.button": "Pay {amount} DZD (test)",
    "planCard.title": "Your plan",
    "planCard.name.trial": "Free trial",
    "planCard.name.monthly": "Monthly plan",
    "planCard.name.block": "Block plan",
    "planCard.state.active": "Active",
    "planCard.state.endingSoon": "Ending soon",
    "planCard.state.expired": "Expired",
    "planCard.state.cancelled": "Cancelled",
    "planCard.state.revoked": "Access removed",
    "planCard.state.suspended": "Suspended",
    "planCard.startedLabel": "Start date",
    "planCard.endsLabel": "End date",
    "planCard.started": "Started {date}",
    "planCard.ends": "Ends {date}",
    "planCard.endedOn": "Ended {date}",
    "planCard.daysLeft_one": "{count} day left",
    "planCard.daysLeft_other": "{count} days left",
    "planCard.lessonsLeft_one": "{count} lesson left",
    "planCard.lessonsLeft_other": "{count} lessons left",
    "planCard.dailyAllowance_one": "{count} lesson per day",
    "planCard.dailyAllowance_other": "{count} lessons per day",
    "planCard.notice.endingSoon": "Your plan ends soon. Renew to keep your access.",
    "planCard.notice.expired": "Your plan has ended. Renew to keep learning.",
    "planCard.notice.cancelled": "Your plan was cancelled.",
    "planCard.notice.revoked": "Your access was removed. Please contact support.",
    "planCard.notice.suspended": "Your account is suspended. Please contact support.",
    "planCard.notice.accountDeletion": "Your plan ended when you asked to delete your account.",
    "subscribePage.blockActive": "Your {level} block is active - {done} of {total} done. You can buy your next block when you finish lesson {total}.",
    "checkoutError.blockStillActive": "Your {level} block is active - {done} of {total} done. You can buy your next block when you finish lesson {total}.",
    "checkoutError.blockStillActiveNoFigures": "Your current block is still active. You can buy your next block when you finish its last lesson.",
    "planCard.notice.blockActive": "You can buy your next block when you finish lesson {total}.",
    "planCard.noPlan": "No active plan",
    "planCard.noPlanHint": "Choose a plan to keep learning.",
    "planCard.button.choose": "Choose a plan",
    "planCard.button.renew": "Renew",
    "planCard.button.upgrade": "Upgrade",
    "planCard.button.manage": "Manage plan",
    "consent.label": "I have read and agree to the {terms} and the {privacy}.",
    "consent.termsName": "Terms of Use",
    "consent.privacyName": "Privacy Policy",
    "consent.refundLine": "Questions about refunds or cancelling? Read the {refunds}.",
    "consent.refundName": "refund and cancellation rules",
    "consent.required": "Please tick the box to agree to the Terms of Use and the Privacy Policy before you pay."
  },
  writing: {
    "coachFeedbackPanel.focusForNextTime": "Focus for next time",
    "errorClusterList.correction": "Correction",
    "errorClusterList.discourse": "Discourse",
    "errorClusterList.ideas": "Ideas",
    "errorClusterList.instanceCount_one": "{count} instance",
    "errorClusterList.instanceCount_other": "{count} instances",
    "errorClusterList.language": "Language",
    "errorClusterList.noRecurringIssuesFoundInThis": "No recurring issues found in this area — nice work.",
    "errorClusterList.original": "Original",
    "scaffoldingPanel.helpWithThisTask": "Help with this task",
    "scaffoldingPanel.ideasToCover": "Ideas to cover",
    "scaffoldingPanel.showHints": "Show hints",
    "scaffoldingPanel.vocabulary": "Vocabulary",
    "stemEditor.completeTheSentence": "Complete the sentence…",
    "stemEditor.stemcompletionminwordswordsMoreToGo": " — {stemCompletionMinWordswords} more to go",
    "stemEditor.wordCount_one": "{count} word",
    "stemEditor.wordCount_other": "{count} words",
    "taskCard.atLeast": " at least ",
    "taskCard.audience": "Audience:",
    "taskCard.wordCount": "Word count:",
    "taskCard.words": " words",
    "taskCard.writingTask": "Writing Task",
    "writingEditor.minWordcountmin": " / min {wordCountMin}",
    "writingEditor.moreWordsToGo_one": "{count} more word to go",
    "writingEditor.moreWordsToGo_other": "{count} more words to go",
    "writingEditor.responseTooShort_one": "Your response is a bit short — aim for at least {count} word.",
    "writingEditor.responseTooShort_other": "Your response is a bit short — aim for at least {count} words.",
    "writingEditor.startWritingHere": "Start writing here…",
    "writingEditor.wordCount_one": "{count} word",
    "writingEditor.wordCount_other": "{count} words",
    "writingScoreCard.cefrProfile": "CEFR profile: ",
    "writingScoreCard.dimensionLabel.audienceAndRegister": "Audience & Register",
    "writingScoreCard.dimensionLabel.coherenceAndCohesion": "Coherence & Cohesion",
    "writingScoreCard.dimensionLabel.linguisticRangeAndAccuracy": "Linguistic Range & Accuracy",
    "writingScoreCard.dimensionLabel.targetVocabularyUse": "Target Vocabulary Use",
    "writingScoreCard.dimensionLabel.taskAchievement": "Task Achievement",
    "writingScoreCard.overallScore": "Overall Score",
    "modelAnswerPanel.title": "Here is one way to write it",
    "modelAnswerPanel.intro": "You have used all your tries on this task, so here is a model answer to learn from. It is only one way to do it - your own words are fine too.",
    "modelAnswerPanel.recoveryTitle": "Before you go on",
    "vocabReminder.heading": "Words to use in your answer",
    "vocabReminder.line": "Use these words in your answer to meet the task's objectives."
  },
} as const;

export default catalog;
export type Catalog = typeof catalog;
